import { useState, useEffect, useRef } from "react";

const SUPABASE_URL = "https://xuxmdnwifeqyftestcsi.supabase.co";
const SUPABASE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inh1eG1kbndpZmVxeWZ0ZXN0Y3NpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ1NDkyMTksImV4cCI6MjA5MDEyNTIxOX0.aohPkWvL2-lbPGFiClZWW2kT0exMSygf-71UXb_cu-M"; 
const MATERIAL_OPTIONS = [
  "Cajas de Piso (Plank) - Madera", "Cajas de Piso (Plank)- Vinyl", "Cajas de Piso (Herringbone)- Madera",
  "Cajas de Piso (Herrinbone) - Vinyl",
  "Palos de Lunawood","Cubetas de Pegamento","Cajas de Tornillos",
  "Láminas de MDF","Zócalos","Perfiles de Transición",
  "Puertas","Muebles de Cocina","Accesorios","Otro",
];

const supabase = {
  async query(table, method = "GET", body = null, filter = "") {
    const url = `${SUPABASE_URL}/rest/v1/${table}${filter}`;
    const res = await fetch(url, {
      method,
      headers: { apikey: SUPABASE_KEY, Authorization: `Bearer ${SUPABASE_KEY}`, "Content-Type": "application/json", Prefer: "return=representation" },
      body: body ? JSON.stringify(body) : null,
    });
    if (!res.ok) { const err = await res.text(); throw new Error(err); }
    const text = await res.text();
    return text ? JSON.parse(text) : [];
  },
  async uploadPhoto(file, path) {
    const url = `${SUPABASE_URL}/storage/v1/object/delivery-photos/${path}`;
    const res = await fetch(url, { method: "POST", headers: { apikey: SUPABASE_KEY, Authorization: `Bearer ${SUPABASE_KEY}`, "Content-Type": file.type || "image/jpeg" }, body: file });
    if (!res.ok) { const errBody = await res.text(); throw new Error(`Upload failed (${res.status}): ${errBody}`); }
    return `${SUPABASE_URL}/storage/v1/object/public/delivery-photos/${path}`;
  },
};

const brandGreen = "#2d3a2e";
function todayStr() { return new Date().toISOString().split("T")[0]; }
function formatDate(d) { if (!d) return ""; return new Date(d + "T00:00:00").toLocaleDateString("es-DO", { weekday: "long", day: "numeric", month: "long" }); }
function formatTime(iso) { if (!iso) return ""; return new Date(iso).toLocaleTimeString("es-DO", { hour: "2-digit", minute: "2-digit" }); }
// Safely parse JSON — handles text columns (string), jsonb columns (already parsed), null, and double-encoded strings
function safeParse(val, fallback) {
  if (val === null || val === undefined || val === "") return fallback;
  if (typeof val === "object") return val; // already parsed (jsonb column)
  try {
    const parsed = JSON.parse(val);
    // Handle double-encoded: if parsed result is still a string, parse again
    if (typeof parsed === "string") return JSON.parse(parsed);
    return parsed;
  } catch (e) { return fallback; }
}
const inputStyle = { width: "100%", padding: "11px 14px", borderRadius: 10, border: "1.5px solid #e2e8f0", fontSize: 16, outline: "none", background: "white", boxSizing: "border-box" };
const labelStyle = { fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 6 };

function StatusBadge({ status }) {
  const map = { pendiente: { label: "Pendiente", bg: "#f1f5f9", color: "#64748b", dot: "#94a3b8" }, en_ruta: { label: "En Ruta", bg: "#fef9c3", color: "#854d0e", dot: "#eab308" }, entregado: { label: "Entregado", bg: "#f0fdf4", color: "#166534", dot: "#22c55e" }, problema: { label: "Problema", bg: "#fff1f2", color: "#9f1239", dot: "#f43f5e" }, cancelado: { label: "Cancelado", bg: "#f9a096", color: "#a12121", dot: "#a14343" },};
  const s = map[status] || map.pendiente;
  return <span style={{ display: "inline-flex", alignItems: "center", gap: 5, background: s.bg, color: s.color, padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 600 }}><span style={{ width: 6, height: 6, borderRadius: "50%", background: s.dot, display: "inline-block" }} />{s.label}</span>;
}

function DispatchTypeBadge({ type }) {
  const map = {
    entrega: { label: "Entrega", bg: "#eff6ff", color: "#1d4ed8" },
    recogida: { label: "Recogida", bg: "#fff7ed", color: "#c2410c" },
    retiro: { label: "Retiro", bg: "#f5f3ff", color: "#6d28d9" },
  };
  const s = map[type || "entrega"] || map.entrega;
  return <span style={{ display: "inline-flex", alignItems: "center", background: s.bg, color: s.color, padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 600 }}>{s.label}</span>;
}


function SignaturePad({ onSign, signed }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const lastPos = useRef(null);
  const getPos = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    const src = e.touches ? e.touches[0] : e;
    return { x: (src.clientX - rect.left) * scaleX, y: (src.clientY - rect.top) * scaleY };
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; const pos = getPos(e); lastPos.current = pos; const ctx = canvasRef.current.getContext("2d"); ctx.beginPath(); ctx.moveTo(pos.x, pos.y); };
  const draw = (e) => {
    e.preventDefault(); if (!drawing.current) return;
    const pos = getPos(e); const ctx = canvasRef.current.getContext("2d");
    ctx.lineWidth = 2.5; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = brandGreen;
    ctx.beginPath(); ctx.moveTo(lastPos.current.x, lastPos.current.y); ctx.lineTo(pos.x, pos.y); ctx.stroke();
    lastPos.current = pos;
  };
  const end = (e) => { e.preventDefault(); drawing.current = false; lastPos.current = null; onSign(canvasRef.current.toDataURL()); };
  const clear = () => { const ctx = canvasRef.current.getContext("2d"); ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height); onSign(null); };
  return (
    <div>
      <div style={{ position: "relative", width: "100%", borderRadius: 10, overflow: "hidden", border: `2px dashed ${signed ? "#bbf7d0" : "#cbd5e1"}`, background: signed ? "#f0fdf4" : "#f8fafc" }}>
        <canvas ref={canvasRef} width={600} height={200} style={{ display: "block", width: "100%", height: 160, touchAction: "none" }}
          onMouseDown={start} onMouseMove={draw} onMouseUp={end} onMouseLeave={end}
          onTouchStart={start} onTouchMove={draw} onTouchEnd={end} />
        {!signed && <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)", pointerEvents: "none", fontSize: 13, color: "#cbd5e1", whiteSpace: "nowrap" }}>Firmar aquí</div>}
      </div>
      <button onClick={clear} style={{ fontSize: 11, color: "#94a3b8", background: "none", border: "none", cursor: "pointer", marginTop: 4 }}>Limpiar firma</button>
    </div>
  );
}

function MaterialsBuilder({ materials, onChange }) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [specialName, setSpecialName] = useState("");
  const addMaterial = (name) => { onChange([...materials, { name, quantity: 1, unit: "unidades" }]); setShowDropdown(false); };
  const addSpecial = () => { if (!specialName.trim()) return; onChange([...materials, { name: specialName.trim(), quantity: 1, unit: "unidades" }]); setSpecialName(""); setShowDropdown(false); };
  const updateMaterial = (i, field, value) => { const u = [...materials]; u[i] = { ...u[i], [field]: value }; onChange(u); };
  const removeMaterial = (i) => onChange(materials.filter((_, idx) => idx !== i));
  return (
    <div>
      {materials.length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 10 }}>
          {materials.map((m, i) => (
            <div key={i} style={{ display: "flex", gap: 8, alignItems: "center", background: "#f8fafc", borderRadius: 8, padding: "8px 10px", border: "1px solid #e2e8f0" }}>
              <span style={{ fontSize: 13, color: brandGreen, fontWeight: 500, flex: 1 }}>{m.name}</span>
              <input type="number" value={m.quantity} min={1} onChange={e => updateMaterial(i, "quantity", parseInt(e.target.value) || 1)} style={{ width: 60, padding: "5px 8px", borderRadius: 6, border: "1px solid #e2e8f0", fontSize: 13, textAlign: "center" }} />
              <input type="text" value={m.unit} onChange={e => updateMaterial(i, "unit", e.target.value)} style={{ width: 80, padding: "5px 8px", borderRadius: 6, border: "1px solid #e2e8f0", fontSize: 12 }} placeholder="unidad" />
              <button onClick={() => removeMaterial(i)} style={{ background: "none", border: "none", cursor: "pointer", color: "#f43f5e", fontSize: 18, padding: 0, lineHeight: 1 }}>×</button>
            </div>
          ))}
        </div>
      )}
      <div style={{ position: "relative" }}>
        <button onClick={() => setShowDropdown(!showDropdown)} style={{ width: "100%", padding: "10px 14px", borderRadius: 10, border: "1.5px dashed #e2e8f0", background: "white", cursor: "pointer", fontSize: 13, color: "#64748b", textAlign: "left" }}>+ Agregar material</button>
        {showDropdown && (
          <div style={{ position: "absolute", top: "100%", left: 0, right: 0, background: "white", border: "1px solid #e2e8f0", borderRadius: 10, zIndex: 100, maxHeight: 220, overflowY: "auto", boxShadow: "0 4px 16px rgba(0,0,0,0.08)" }}>
            {MATERIAL_OPTIONS.map(opt => (
              <button key={opt} onClick={() => addMaterial(opt)} style={{ display: "block", width: "100%", textAlign: "left", padding: "10px 14px", border: "none", borderBottom: "1px solid #f1f5f9", background: "white", cursor: "pointer", fontSize: 13, color: "#374151" }}
                onMouseEnter={e => e.target.style.background = "#f8fafc"} onMouseLeave={e => e.target.style.background = "white"}>{opt}</button>
            ))}
            <div style={{ padding: "8px 10px", borderTop: "2px solid #e2e8f0" }}>
              <div style={{ fontSize: 10, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>Artículo especial</div>
              <div style={{ display: "flex", gap: 6 }}>
                <input type="text" value={specialName} onChange={e => setSpecialName(e.target.value)} onKeyDown={e => e.key === "Enter" && addSpecial()} placeholder="Nombre del artículo..." style={{ flex: 1, padding: "6px 8px", borderRadius: 6, border: "1px solid #e2e8f0", fontSize: 12, outline: "none" }} />
                <button onClick={addSpecial} style={{ padding: "6px 12px", borderRadius: 6, background: brandGreen, color: "white", border: "none", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>+</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function LocationsBuilder({ locations, onChange }) {
  const addLocation = () => onChange([...locations, { floor: "", address: "", contact: "", notes: "" }]);
  const updateLocation = (i, field, value) => { const u = [...locations]; u[i] = { ...u[i], [field]: value }; onChange(u); };
  const removeLocation = (i) => { if (locations.length === 1) return; onChange(locations.filter((_, idx) => idx !== i)); };
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {locations.map((loc, i) => (
        <div key={i} style={{ background: "#f8fafc", borderRadius: 10, border: "1px solid #e2e8f0", padding: 12 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
            <span style={{ fontSize: 12, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.06em" }}>Piso / Ubicación {i + 1}</span>
            {locations.length > 1 && <button onClick={() => removeLocation(i)} style={{ background: "none", border: "none", cursor: "pointer", color: "#f43f5e", fontSize: 18, padding: 0, lineHeight: 1 }}>×</button>}
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <input type="text" value={loc.floor} onChange={e => updateLocation(i, "floor", e.target.value)} placeholder="Piso / Apartamento (Ej: Piso 4, Apt 4B)" style={{ ...inputStyle, fontSize: 13 }} />
            <input type="text" value={loc.address} onChange={e => updateLocation(i, "address", e.target.value)} placeholder="Dirección (si es diferente)" style={{ ...inputStyle, fontSize: 13 }} />
            <input type="text" value={loc.contact} onChange={e => updateLocation(i, "contact", e.target.value)} placeholder="Contacto en sitio (nombre y teléfono)" style={{ ...inputStyle, fontSize: 13 }} />
            <input type="text" value={loc.notes} onChange={e => updateLocation(i, "notes", e.target.value)} placeholder="Notas (ascensor, parqueo...)" style={{ ...inputStyle, fontSize: 13 }} />
          </div>
        </div>
      ))}
      <button onClick={addLocation} style={{ padding: "10px", borderRadius: 10, border: "1.5px dashed #e2e8f0", background: "white", cursor: "pointer", fontSize: 13, color: "#64748b" }}>+ Agregar otro piso / ubicación</button>
    </div>
  );
}

function AdminView() {
  const [screen, setScreen] = useState("dashboard");
  const [selectedDate, setSelectedDate] = useState(todayStr());
  const [selectedDispatch, setSelectedDispatch] = useState(null);
  const [viewMode, setViewMode] = useState("hoy");
  const [searchQuery, setSearchQuery] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [dispatches, setDispatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [showValidation, setShowValidation] = useState(false);
  const [filterDateFrom, setFilterDateFrom] = useState("");
  const [filterDateTo, setFilterDateTo] = useState("");
  const [filterCompany, setFilterCompany] = useState("");
  const [notesQuery, setNotesQuery] = useState("");
  const [form, setForm] = useState({ date: todayStr(), client: "", project: "", so_number: "", company: "", driver: "Joel", subcontractor_name: "", special_notes: "", destination_zone: "Santo Domingo", dispatch_type: "entrega" });
  const [accessPassUrl, setAccessPassUrl] = useState(null);
  const [accessPassUploading, setAccessPassUploading] = useState(false);
  const [materials, setMaterials] = useState([]);
  const [locations, setLocations] = useState([{ floor: "", address: "", contact: "", notes: "" }]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [selectedDate, viewMode]);

  const load = async () => {
    setLoading(true);
    try {
      let filter;
      if (viewMode === "hoy") {
        filter = `?date=eq.${selectedDate}&order=created_at.asc`;
      } else if (viewMode === "historial") {
        filter = `?status=neq.cancelado&order=created_at.desc`;
      } else if (viewMode === "cancelados") {
        filter = `?status=eq.cancelado&order=created_at.desc`;
      } else {
        const now = new Date();
        const dow = now.getDay();
        const mon = new Date(now);
        mon.setDate(now.getDate() - (dow === 0 ? 6 : dow - 1));
        const sun = new Date(mon);
        sun.setDate(mon.getDate() + 6);
        filter = `?date=gte.${mon.toISOString().split("T")[0]}&date=lte.${sun.toISOString().split("T")[0]}&status=neq.cancelado&order=date.asc,created_at.asc`;
      }
      const data = await supabase.query("dispatches", "GET", null, filter);
      setDispatches(data);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const handleAccessPassUpload = async (e) => {
    const file = e.target.files[0];
    e.target.value = "";
    if (!file) return;
    setAccessPassUploading(true);
    try {
      const url = await supabase.uploadPhoto(file, `access-pass/new-${Date.now()}.jpg`);
      setAccessPassUrl(url);
    } catch (err) { alert("Error subiendo pase de acceso: " + err.message); }
    setAccessPassUploading(false);
  };

  const handleAdd = async () => {
    if (!form.client || !form.project || !form.so_number) {
      setShowValidation(true);
      return;
    }
    setShowValidation(false);
    setSaving(true);
    try {
      const totalBoxes = materials.reduce((sum, m) => sum + (m.quantity || 0), 0);
      await supabase.query("dispatches", "POST", { ...form, boxes: totalBoxes, subcontractor_name: form.driver === "Subcontratista" ? form.subcontractor_name : null, status: "pendiente", dispatch_type: form.dispatch_type || "entrega", materials_manifest: JSON.stringify(materials), locations: JSON.stringify(locations), access_pass_url: accessPassUrl || null });
      setForm({ date: todayStr(), client: "", project: "", so_number: "", company: "", driver: "Joel", subcontractor_name: "", special_notes: "", destination_zone: "Santo Domingo", dispatch_type: "entrega" });
      setMaterials([]); setLocations([{ floor: "", address: "", contact: "", notes: "" }]);
      setAccessPassUrl(null);
      setScreen("dashboard"); load();
    } catch (e) { alert("Error: " + e.message); }
    setSaving(false);
  };

  const filtered = dispatches.filter(d => {
      const matchesStatus = filterStatus === "all" || d.status === filterStatus;
      const matchesSearch = searchQuery === "" ||
        d.client?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        d.project?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        d.so_number?.toLowerCase().includes(searchQuery.toLowerCase());
      const sortDate = (d.status === "entregado" && d.completed_at) ? d.completed_at.split("T")[0] : d.date;
      const matchesDateFrom = !filterDateFrom || sortDate >= filterDateFrom;
      const matchesDateTo = !filterDateTo || sortDate <= filterDateTo;
      const matchesCompany = !filterCompany || d.company === filterCompany;
      const matchesNotes = !notesQuery || d.special_notes?.toLowerCase().includes(notesQuery.toLowerCase());
      return matchesStatus && matchesSearch && matchesDateFrom && matchesDateTo && matchesCompany && matchesNotes;
  }).sort((a, b) => {
    if (viewMode !== "historial") return 0;
    const aDate = (a.status === "entregado" && a.completed_at) ? a.completed_at.split("T")[0] : a.date;
    const bDate = (b.status === "entregado" && b.completed_at) ? b.completed_at.split("T")[0] : b.date;
    return bDate.localeCompare(aDate);
  });

    const dateFilteredDispatches = (filterDateFrom || filterDateTo || filterCompany) ? dispatches.filter(d => {
      const sortDate = (d.status === "entregado" && d.completed_at) ? d.completed_at.split("T")[0] : d.date;
      return (!filterDateFrom || sortDate >= filterDateFrom) && (!filterDateTo || sortDate <= filterDateTo) && (!filterCompany || d.company === filterCompany);
    }) : dispatches;
    const counts = {
      total: dateFilteredDispatches.length,
      pendiente: dateFilteredDispatches.filter(d => d.status === "pendiente").length,
      en_ruta: dateFilteredDispatches.filter(d => d.status === "en_ruta").length,
      entregado: dateFilteredDispatches.filter(d => d.status === "entregado").length,
    };

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc", fontFamily: "'DM Sans', 'Helvetica Neue', sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
      <div style={{ position: "sticky", top: 0, zIndex: 50, background: "rgba(248,250,252,0.95)", backdropFilter: "blur(8px)", borderBottom: "1px solid #e2e8f0" }}>
        <div style={{ maxWidth: 680, margin: "0 auto", padding: "12px 16px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 32, height: 32, borderRadius: 8, background: brandGreen, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
            </div>
            <div><div style={{ fontSize: 13, fontWeight: 700, color: brandGreen, letterSpacing: "0.12em" }}>CONTIDECO</div><div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 500, letterSpacing: "0.1em" }}>DESPACHOS — ADMIN</div></div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            {screen !== "dashboard" && <button onClick={() => setScreen("dashboard")} style={{ fontSize: 12, color: "#64748b", background: "none", border: "none", cursor: "pointer" }}>← Volver</button>}
            {screen === "dashboard" && <button onClick={() => setScreen("add")} style={{ fontSize: 13, fontWeight: 600, color: "white", background: brandGreen, border: "none", borderRadius: 8, padding: "7px 14px", cursor: "pointer" }}>+ Agregar</button>}
          </div>
        </div>
      </div>
      <div style={{ maxWidth: 680, margin: "0 auto", padding: "20px 16px" }}>
        {screen === "dashboard" && (
          <div>
            <div style={{ display: "flex", background: "white", border: "1px solid #e2e8f0", borderRadius: 10, padding: 3, marginBottom: 16, gap: 3 }}>
  {["hoy", "semana", "historial", "cancelados"].map(mode => (
    <button key={mode} onClick={() => { setViewMode(mode); setSearchQuery(""); setFilterStatus("all"); setFilterDateFrom(""); setFilterDateTo(""); setFilterCompany(""); setNotesQuery(""); }}
      style={{ flex: 1, padding: "6px 4px", borderRadius: 8, fontSize: 12, fontWeight: 500, border: "none", cursor: "pointer", background: viewMode === mode ? brandGreen : "transparent", color: viewMode === mode ? "white" : "#64748b" }}>
      {mode === "hoy" ? "Hoy" : mode === "semana" ? "Semana" : mode === "historial" ? "Historial" : "Cancelados"}
    </button>
  ))}
</div>

{viewMode === "hoy" && (
  <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
    <input type="date" value={selectedDate} onChange={e => setSelectedDate(e.target.value)} style={{ ...inputStyle, width: "auto", fontSize: 13 }} />
    <span style={{ fontSize: 14, color: "#64748b", textTransform: "capitalize" }}>{formatDate(selectedDate)}</span>
  </div>
)}

{(viewMode === "historial" || viewMode === "cancelados") && (
  <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)}
    placeholder="Buscar por cliente, proyecto o SO#..."
    style={{ ...inputStyle, marginBottom: 12, fontSize: 13 }} />
)}
{viewMode === "historial" && (
  <div style={{ display: "flex", gap: 8, marginBottom: 10, alignItems: "center" }}>
    <input type="date" value={filterDateFrom} onChange={e => setFilterDateFrom(e.target.value)} style={{ ...inputStyle, width: "auto", flex: 1, fontSize: 13 }} />
    <span style={{ fontSize: 12, color: "#94a3b8", flexShrink: 0 }}>→</span>
    <input type="date" value={filterDateTo} onChange={e => setFilterDateTo(e.target.value)} style={{ ...inputStyle, width: "auto", flex: 1, fontSize: 13 }} />
    {(filterDateFrom || filterDateTo) && <button onClick={() => { setFilterDateFrom(""); setFilterDateTo(""); }} style={{ fontSize: 11, color: "#94a3b8", background: "none", border: "0.5px solid #e2e8f0", borderRadius: 6, padding: "4px 8px", cursor: "pointer", flexShrink: 0 }}>✕</button>}
  </div>
)}
{viewMode === "historial" && (
  <div style={{ display: "flex", gap: 6, marginBottom: 12 }}>
    {[["", "Todas"], ["Sterling", "Sterling"], ["231 Forest", "231 Forest"]].map(([val, lbl]) => (
      <button key={val} onClick={() => setFilterCompany(filterCompany === val ? "" : val)}
        style={{ padding: "5px 12px", borderRadius: 20, fontSize: 12, fontWeight: 500, border: `1px solid ${filterCompany === val ? brandGreen : "#e2e8f0"}`, background: filterCompany === val ? brandGreen : "white", color: filterCompany === val ? "white" : "#64748b", cursor: "pointer" }}>
        {lbl}
      </button>
    ))}
  </div>
)}
{viewMode === "historial" && (
  <div style={{ position: "relative", marginBottom: 16 }}>
    <input type="text" value={notesQuery} onChange={e => setNotesQuery(e.target.value)}
      placeholder="🔍 Buscar en notas especiales..."
      style={{ ...inputStyle, fontSize: 13, paddingRight: notesQuery ? 32 : 14, background: notesQuery ? "#f0fdf4" : "white", borderColor: notesQuery ? brandGreen : "#e2e8f0" }} />
    {notesQuery && <button onClick={() => setNotesQuery("")} style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", fontSize: 14, color: "#94a3b8", cursor: "pointer" }}>✕</button>}
  </div>
)}

{viewMode !== "cancelados" && viewMode !== "semana" && (
<div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 10, marginBottom: 20 }}>
  {[
    { label: "Total", value: counts.total, color: brandGreen, status: "all" },
    { label: "Pendiente", value: counts.pendiente, color: "#94a3b8", status: "pendiente" },
    { label: "En Ruta", value: counts.en_ruta, color: "#eab308", status: "en_ruta" },
    { label: "Entregado", value: counts.entregado, color: "#22c55e", status: "entregado" },
  ].map(s => (
    <div key={s.label} onClick={() => setFilterStatus(filterStatus === s.status ? "all" : s.status)}
      style={{ background: filterStatus === s.status ? "#f0f5f0" : "white", border: `1px solid ${filterStatus === s.status ? brandGreen : "#e2e8f0"}`, borderRadius: 12, padding: "12px 10px", textAlign: "center", cursor: "pointer" }}>
      <div style={{ fontSize: 22, fontWeight: 700, color: s.color }}>{s.value}</div>
      <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600, letterSpacing: "0.06em", textTransform: "uppercase" }}>{s.label}</div>
    </div>
  ))}
</div>
)}
            {loading ? <div style={{ textAlign: "center", padding: 40, color: "#94a3b8" }}>Cargando...</div> : viewMode === "semana" ? (() => {
              if (dispatches.length === 0) return (
                <div style={{ textAlign: "center", padding: 40, background: "white", borderRadius: 16, border: "1px solid #e2e8f0" }}>
                  <div style={{ fontSize: 32, marginBottom: 8 }}>📅</div>
                  <p style={{ color: "#94a3b8", fontSize: 14 }}>Sin despachos esta semana</p>
                </div>
              );
              const today = todayStr();
              const byDate = dispatches.reduce((acc, d) => { if (!acc[d.date]) acc[d.date] = []; acc[d.date].push(d); return acc; }, {});
              const dates = Object.keys(byDate).sort();
              return (
                <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
                  {dates.map(date => {
                    const isToday = date === today;
                    return (
                      <div key={date}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
                          <span style={{ fontSize: 12, fontWeight: 700, color: isToday ? brandGreen : "#64748b", textTransform: "capitalize" }}>{formatDate(date)}</span>
                          {isToday && <span style={{ fontSize: 10, fontWeight: 700, background: brandGreen, color: "white", padding: "1px 7px", borderRadius: 8 }}>Hoy</span>}
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                          {byDate[date].map(d => {
                            const dLocs = safeParse(d.locations, []);
                            const dMats = safeParse(d.materials_manifest, []);
                            return (
                              <div key={d.id} onClick={() => { setSelectedDispatch(d); setScreen("detail"); }} style={{ background: "white", border: "1px solid #e2e8f0", borderRadius: 14, padding: "14px 16px", cursor: "pointer" }}
                                onMouseEnter={e => e.currentTarget.style.boxShadow = "0 2px 12px rgba(0,0,0,0.06)"} onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
                                  <div><div style={{ fontSize: 15, fontWeight: 600, color: brandGreen }}>{d.project}</div><div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>{d.client}</div></div>
                                  <div style={{ display: "flex", gap: 6, flexDirection: "column", alignItems: "flex-end" }}><DispatchTypeBadge type={d.dispatch_type} /><StatusBadge status={d.status} /></div>
                                </div>
                                <div style={{ display: "flex", gap: 12, fontSize: 12, color: "#94a3b8", flexWrap: "wrap" }}>
                                  <span>📋 {d.so_number}</span>
                                  <span>🚗 {d.driver === "Subcontratista" ? d.subcontractor_name || "Subcontratista" : d.driver}</span>
                                  {dLocs.length > 0 && <span>📍 {dLocs.length} ubicación{dLocs.length > 1 ? "es" : ""}</span>}
                                  {dMats.length > 0 && <span>📦 {dMats.length} material{dMats.length > 1 ? "es" : ""}</span>}
                                  {d.destination_zone === "Este (Cap Cana / Casa de Campo / Punta Cana)" && <span style={{ fontWeight: 700, color: "#f97316" }}>🌴 Este</span>}
                                </div>
                                {d.status === "entregado" && d.completed_at && <div style={{ marginTop: 6, fontSize: 11, color: "#22c55e", fontWeight: 500 }}>✓ Entregado {formatTime(d.completed_at)} — {d.recipient_name}</div>}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })() : dispatches.length === 0 ? (
              <div style={{ textAlign: "center", padding: 40, background: "white", borderRadius: 16, border: "1px solid #e2e8f0" }}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>📦</div>
                <p style={{ color: "#94a3b8", fontSize: 14 }}>No hay despachos para esta fecha</p>
                <button onClick={() => setScreen("add")} style={{ marginTop: 12, fontSize: 13, fontWeight: 600, color: "white", background: brandGreen, border: "none", borderRadius: 8, padding: "8px 16px", cursor: "pointer" }}>Agregar Despacho</button>
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {filtered.map(d => {
                  const dLocs = safeParse(d.locations, []);
                  const dMats = safeParse(d.materials_manifest, []);
                  return (
                    <div key={d.id} onClick={() => { setSelectedDispatch(d); setScreen("detail"); }} style={{ background: "white", border: "1px solid #e2e8f0", borderRadius: 14, padding: "14px 16px", cursor: "pointer" }}
                      onMouseEnter={e => e.currentTarget.style.boxShadow = "0 2px 12px rgba(0,0,0,0.06)"} onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
                        <div><div style={{ fontSize: 15, fontWeight: 600, color: brandGreen }}>{d.project}</div><div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>{d.client}</div></div>
                        <div style={{ display: "flex", gap: 6, flexDirection: "column", alignItems: "flex-end" }}><DispatchTypeBadge type={d.dispatch_type} /><StatusBadge status={d.status} /></div>
                      </div>
                      <div style={{ display: "flex", gap: 12, fontSize: 12, color: "#94a3b8", flexWrap: "wrap" }}>
                      {viewMode !== "hoy" && <span>📅 {formatDate(d.date)}</span>}
                        <span>📋 {d.so_number}</span>
                        <span>🚗 {d.driver === "Subcontratista" ? d.subcontractor_name || "Subcontratista" : d.driver}</span>
                        {dLocs.length > 0 && <span>📍 {dLocs.length} ubicación{dLocs.length > 1 ? "es" : ""}</span>}
                        {dMats.length > 0 && <span>📦 {dMats.length} material{dMats.length > 1 ? "es" : ""}</span>}
                      </div>
                      {d.status === "entregado" && d.completed_at && <div style={{ marginTop: 6, fontSize: 11, color: "#22c55e", fontWeight: 500 }}>✓ Entregado {formatTime(d.completed_at)} — {d.recipient_name}</div>}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}
        {screen === "add" && (
          <div style={{ background: "white", borderRadius: 16, border: "1px solid #e2e8f0", padding: 20 }}>
            <h2 style={{ fontSize: 18, fontWeight: 700, color: brandGreen, marginBottom: 20, marginTop: 0 }}>Nuevo Despacho</h2>
            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              <div>
                <label style={labelStyle}>Tipo de despacho</label>
                <div style={{ display: "flex", gap: 8 }}>
                  {[
                    { value: "entrega", label: "Entrega", desc: "Almacén → Obra" },
                    { value: "recogida", label: "Recogida", desc: "Recoger material" },
                    { value: "retiro", label: "Retiro", desc: "Cliente retira" },
                  ].map(opt => (
                    <button key={opt.value} type="button" onClick={() => setForm({ ...form, dispatch_type: opt.value })}
                      style={{ flex: 1, padding: "10px 6px", borderRadius: 10, border: `1.5px solid ${form.dispatch_type === opt.value ? (opt.value === "entrega" ? "#1d4ed8" : opt.value === "recogida" ? "#c2410c" : "#6d28d9") : "#e2e8f0"}`, background: form.dispatch_type === opt.value ? (opt.value === "entrega" ? "#eff6ff" : opt.value === "recogida" ? "#fff7ed" : "#f5f3ff") : "white", cursor: "pointer", textAlign: "center" }}>
                      <div style={{ fontSize: 13, fontWeight: 600, color: form.dispatch_type === opt.value ? (opt.value === "entrega" ? "#1d4ed8" : opt.value === "recogida" ? "#c2410c" : "#6d28d9") : "#374151" }}>{opt.label}</div>
                      <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 2 }}>{opt.desc}</div>
                    </button>
                  ))}
                </div>
              </div>
              <div><label style={labelStyle}>Fecha</label><input type="date" value={form.date} onChange={e => setForm({ ...form, date: e.target.value })} style={inputStyle} /></div>
              <div>
                <label style={labelStyle}>Cliente/s <span style={{ color: "#f43f5e" }}>*</span></label>
                <input type="text" value={form.client} onChange={e => { setForm({ ...form, client: e.target.value }); setShowValidation(false); }} onBlur={e => setForm(f => ({ ...f, client: e.target.value }))} placeholder="Nombre del cliente" style={{ ...inputStyle, borderColor: showValidation && !form.client ? "#f43f5e" : "#e2e8f0" }} />
                {showValidation && !form.client && <p style={{ fontSize: 12, color: "#f43f5e", margin: "4px 0 0" }}>Campo requerido</p>}
              </div>
              <div>
                <label style={labelStyle}>Proyecto/s - Obra/s <span style={{ color: "#f43f5e" }}>*</span></label>
                <input type="text" value={form.project} onChange={e => { setForm({ ...form, project: e.target.value }); setShowValidation(false); }} onBlur={e => setForm(f => ({ ...f, project: e.target.value }))} placeholder="Torre Bella Vista Apt 4B" style={{ ...inputStyle, borderColor: showValidation && !form.project ? "#f43f5e" : "#e2e8f0" }} />
                {showValidation && !form.project && <p style={{ fontSize: 12, color: "#f43f5e", margin: "4px 0 0" }}>Campo requerido</p>}
              </div>
              <div style={{ display: "flex", gap: 10 }}>
                <div style={{ flex: 2 }}>
                  <label style={labelStyle}>Número de Orden/es (SO#) <span style={{ color: "#f43f5e" }}>*</span></label>
                  <input type="text" value={form.so_number} onChange={e => { setForm({ ...form, so_number: e.target.value }); setShowValidation(false); }} onBlur={e => setForm(f => ({ ...f, so_number: e.target.value }))} placeholder="SO-2026-0142" style={{ ...inputStyle, borderColor: showValidation && !form.so_number ? "#f43f5e" : "#e2e8f0" }} />
                  {showValidation && !form.so_number && <p style={{ fontSize: 12, color: "#f43f5e", margin: "4px 0 0" }}>Campo requerido</p>}
                </div>
                <div style={{ flex: 1 }}>
                  <label style={labelStyle}>Empresa</label>
                  <select value={form.company} onChange={e => setForm({ ...form, company: e.target.value })} style={inputStyle}>
                    <option value="">—</option>
                    <option value="Sterling">Sterling</option>
                    <option value="231 Forest">231 Forest</option>
                  </select>
                </div>
              </div>
              <div>
                <label style={labelStyle}>Conductor</label>
                <select value={form.driver} onChange={e => setForm({ ...form, driver: e.target.value })} style={inputStyle}><option value="Joel">Joel</option><option value="Subcontratista">Subcontratista</option></select>
              </div>
              {form.driver === "Subcontratista" && <div><label style={labelStyle}>Nombre del Subcontratista</label><input type="text" value={form.subcontractor_name} onChange={e => setForm({ ...form, subcontractor_name: e.target.value })} onBlur={e => setForm(f => ({ ...f, subcontractor_name: e.target.value }))} placeholder="Nombre completo" style={inputStyle} /></div>}
              <div>
                <label style={labelStyle}>Zona de destino</label>
                <select value={form.destination_zone} onChange={e => setForm({ ...form, destination_zone: e.target.value })} style={inputStyle}>
                  <option value="Santo Domingo">Santo Domingo</option>
                  <option value="Este (Cap Cana / Casa de Campo / Punta Cana)">Este (Cap Cana / Casa de Campo / Punta Cana)</option>
                </select>
              </div>
              {form.destination_zone === "Este (Cap Cana / Casa de Campo / Punta Cana)" && (
                <div>
                  <label style={labelStyle}>Pase de acceso</label>
                  {accessPassUrl ? (
                    <div>
                      <img src={accessPassUrl} alt="Pase de acceso" style={{ width: "100%", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 8 }} />
                      <button onClick={() => setAccessPassUrl(null)} style={{ fontSize: 12, color: "#f43f5e", background: "none", border: "none", cursor: "pointer" }}>Quitar</button>
                    </div>
                  ) : (
                    <label style={{ display: "block", padding: "11px 14px", borderRadius: 10, border: "1.5px dashed #e2e8f0", background: "white", cursor: accessPassUploading ? "default" : "pointer", fontSize: 13, color: "#64748b", textAlign: "center" }}>
                      <input type="file" accept="image/*" style={{ display: "none" }} onChange={handleAccessPassUpload} disabled={accessPassUploading} />
                      {accessPassUploading ? "Subiendo..." : "📎 Subir pase de acceso"}
                    </label>
                  )}
                </div>
              )}
              <div><label style={labelStyle}>Pisos / Ubicaciones de Entrega</label><LocationsBuilder locations={locations} onChange={setLocations} /></div>
              <div><label style={labelStyle}>Materiales a Despachar</label><MaterialsBuilder materials={materials} onChange={setMaterials} /></div>
              <div><label style={labelStyle}>Notas Especiales</label><textarea value={form.special_notes} onChange={e => setForm({ ...form, special_notes: e.target.value })} onBlur={e => setForm(f => ({ ...f, special_notes: e.target.value }))} placeholder="Instrucciones adicionales..." rows={3} style={{ ...inputStyle, resize: "vertical" }} /></div>
              <button onClick={handleAdd} disabled={saving} style={{ padding: "13px", borderRadius: 10, background: brandGreen, color: "white", fontSize: 16, fontWeight: 600, border: "none", cursor: "pointer", opacity: saving ? 0.7 : 1 }}>{saving ? "Guardando..." : "Guardar Despacho →"}</button>
              {showValidation && (!form.client || !form.project || !form.so_number) && (
                <div style={{ textAlign: "center", padding: "8px 12px", background: "#fff1f2", border: "1px solid #fecaca", borderRadius: 8 }}>
                  <p style={{ fontSize: 13, color: "#9f1239", margin: 0, fontWeight: 500 }}>Completa los campos marcados con * para guardar</p>
                </div>
              )}
            </div>
          </div>
        )}
        {screen === "detail" && selectedDispatch && <DetailView dispatch={selectedDispatch} onBack={() => { setScreen("dashboard"); load(); }} />}
      </div>
    </div>
  );
}

function DetailView({ dispatch: d, onBack }) {
  const [data, setData] = useState(d);
  const [editing, setEditing] = useState(null); // which field is being edited
  const [editValue, setEditValue] = useState("");
  const [saving, setSaving] = useState(false);
  const [editMaterials, setEditMaterials] = useState([]);
  const [editLocations, setEditLocations] = useState([]);
  const [uploadingAccessPass, setUploadingAccessPass] = useState(false);
  const [showManualForm, setShowManualForm] = useState(false);
  const [manualPhotos, setManualPhotos] = useState({ delivery: [], conduce: [] });
  const [manualDate, setManualDate] = useState(todayStr());
  const [manualTime, setManualTime] = useState(() => { const n = new Date(); return `${String(n.getHours()).padStart(2, "0")}:${String(n.getMinutes()).padStart(2, "0")}`; });
  const [manualRecipient, setManualRecipient] = useState("");
  const [manualUploading, setManualUploading] = useState(null);
  const [manualSubmitting, setManualSubmitting] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { supabase.query("dispatches", "GET", null, `?id=eq.${d.id}`).then(r => r[0] && setData(r[0])); }, []);

  const canEdit = data.status !== "entregado" && data.status !== "cancelado";

  const startEdit = (field, value, alwaysEditable = false) => {
    if (!canEdit && !alwaysEditable) return;
    setEditing(field);
    if (field === "materials") {
      setEditMaterials(safeParse(data.materials_manifest, []));
    } else if (field === "locations") {
      setEditLocations(safeParse(data.locations, []));
    } else {
      setEditValue(value || "");
    }
  };

  const cancelEdit = () => { setEditing(null); setEditValue(""); };

  const uploadDetailAccessPass = async (e) => {
    const file = e.target.files[0];
    e.target.value = "";
    if (!file) return;
    setUploadingAccessPass(true);
    try {
      const projectFolder = data.project.replace(/[^a-zA-Z0-9]/g, "_");
      const url = await supabase.uploadPhoto(file, `access-pass/${projectFolder}/${data.so_number}-${Date.now()}.jpg`);
      await supabase.query("dispatches", "PATCH", { access_pass_url: url }, `?id=eq.${data.id}`);
      setData({ ...data, access_pass_url: url });
    } catch (err) { alert("Error subiendo pase de acceso: " + err.message); }
    setUploadingAccessPass(false);
  };

  const uploadManualPhoto = async (e, category) => {
    const file = e.target.files[0];
    e.target.value = "";
    if (!file) return;
    setManualUploading(category);
    try {
      const projectFolder = data.project.replace(/[^a-zA-Z0-9]/g, "_");
      const soFolder = data.so_number.replace(/[^a-zA-Z0-9]/g, "_");
      const url = await supabase.uploadPhoto(file, `${projectFolder}/${soFolder}/admin-${category}-${Date.now()}.jpg`);
      setManualPhotos(prev => ({ ...prev, [category]: [...prev[category], url] }));
    } catch (err) { alert("Error subiendo foto: " + err.message); }
    setManualUploading(null);
  };

  const removeManualPhoto = (category, index) => {
    setManualPhotos(prev => ({ ...prev, [category]: prev[category].filter((_, i) => i !== index) }));
  };

  const handleManualComplete = async () => {
    setManualSubmitting(true);
    try {
      const completedAt = new Date(`${manualDate}T${manualTime}:00`).toISOString();
      const patch = { status: "entregado", completed_at: completedAt, recipient_name: manualRecipient || null };
      if (manualPhotos.delivery.length > 0) patch.delivery_photos = manualPhotos.delivery;
      if (manualPhotos.conduce.length > 0) patch.conduce_photos = manualPhotos.conduce;
      await supabase.query("dispatches", "PATCH", patch, `?id=eq.${data.id}`);
      const updated = await supabase.query("dispatches", "GET", null, `?id=eq.${data.id}`);
      if (updated[0]) setData(updated[0]);
      setShowManualForm(false);
    } catch (e) { alert("Error: " + e.message); }
    setManualSubmitting(false);
  };

  const saveField = async (field, value) => {
    setSaving(true);
    try {
      let patch = {};
      if (field === "materials") {
        patch.materials_manifest = JSON.stringify(value);
        patch.boxes = value.reduce((sum, m) => sum + (m.quantity || 0), 0);
      } else if (field === "locations") {
        patch.locations = JSON.stringify(value);
      } else {
        patch[field] = value;
      }
      await supabase.query("dispatches", "PATCH", patch, `?id=eq.${data.id}`);
      const updated = await supabase.query("dispatches", "GET", null, `?id=eq.${data.id}`);
      if (updated[0]) setData(updated[0]);
      setEditing(null);
      setEditValue("");
    } catch (e) { alert("Error: " + e.message); }
    setSaving(false);
  };

  const locs = safeParse(data.locations, []);
  const mats = safeParse(data.materials_manifest, []);
  const deliveryMats = safeParse(data.delivery_materials, []);

  const editBtnStyle = { fontSize: 10, color: "#64748b", background: "none", border: "0.5px solid #e2e8f0", borderRadius: 5, padding: "2px 8px", cursor: "pointer", flexShrink: 0 };
  const saveBtnStyle = { flex: 1, padding: "7px", borderRadius: 7, border: "none", background: brandGreen, color: "white", fontSize: 12, fontWeight: 600, cursor: "pointer" };
  const cancelBtnStyle = { flex: 1, padding: "7px", borderRadius: 7, border: "0.5px solid #e2e8f0", background: "white", fontSize: 12, color: "#64748b", cursor: "pointer" };
  const editInputStyle = { width: "100%", padding: "8px 10px", borderRadius: 8, border: "1.5px solid #e2e8f0", fontSize: 13, outline: "none", marginBottom: 8, boxSizing: "border-box" };

  const InlineField = ({ label, field, value, displayValue, type, alwaysEditable }) => {
    const isEditing = editing === field;
    if (isEditing) {
      return (
        <div style={{ padding: "8px 0", borderBottom: "1px solid #e2e8f0" }}>
          <label style={{ fontSize: 10, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 4 }}>{label}</label>
          {type === "date" ? (
            <input type="date" value={editValue} onChange={e => setEditValue(e.target.value)} style={editInputStyle} />
          ) : type === "select-driver" ? (
            <div>
              <select value={editValue} onChange={e => setEditValue(e.target.value)} style={{ ...editInputStyle, marginBottom: 4 }}>
                <option value="Joel">Joel</option>
                <option value="Subcontratista">Subcontratista</option>
              </select>
              {editValue === "Subcontratista" && editing === "driver" && (
                <input type="text" value={data.subcontractor_name || ""} placeholder="Nombre del subcontratista" style={editInputStyle} onChange={e => {/* handled on save */}} disabled />
              )}
            </div>
          ) : type === "select-zone" ? (
            <select value={editValue} onChange={e => setEditValue(e.target.value)} style={{ ...editInputStyle, marginBottom: 4 }}>
              <option value="Santo Domingo">Santo Domingo</option>
              <option value="Este (Cap Cana / Casa de Campo / Punta Cana)">Este (Cap Cana / Casa de Campo / Punta Cana)</option>
            </select>
          ) : type === "select-type" ? (
            <select value={editValue} onChange={e => setEditValue(e.target.value)} style={{ ...editInputStyle, marginBottom: 4 }}>
              <option value="entrega">Entrega (Almacén → Obra)</option>
              <option value="recogida">Recogida (Recoger material)</option>
              <option value="retiro">Retiro en Almacén (Cliente retira)</option>
            </select>
          ) : type === "select-company" ? (
            <select value={editValue} onChange={e => setEditValue(e.target.value)} style={{ ...editInputStyle, marginBottom: 4 }}>
              <option value="">—</option>
              <option value="Sterling">Sterling</option>
              <option value="231 Forest">231 Forest</option>
            </select>
          ) : type === "textarea" ? (
            <textarea value={editValue} onChange={e => setEditValue(e.target.value)} rows={3} style={{ ...editInputStyle, resize: "vertical" }} />
          ) : (
            <input type="text" value={editValue} onChange={e => setEditValue(e.target.value)} style={editInputStyle} />
          )}
          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={cancelEdit} style={cancelBtnStyle}>Cancelar</button>
            <button onClick={() => saveField(field, editValue)} disabled={saving} style={{ ...saveBtnStyle, opacity: saving ? 0.7 : 1 }}>{saving ? "..." : "Guardar"}</button>
          </div>
        </div>
      );
    }
    return (
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 13, padding: "5px 0", borderBottom: "1px solid #e2e8f0" }}>
        <span style={{ color: "#64748b" }}>{label}</span>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontWeight: 500, color: brandGreen }}>{displayValue || value}</span>
          {(canEdit || alwaysEditable) && <button onClick={() => startEdit(field, value, alwaysEditable)} style={editBtnStyle}>Editar</button>}
        </div>
      </div>
    );
  };

  return (
    <div style={{ background: "white", borderRadius: 16, border: "1px solid #e2e8f0", padding: 20 }}>
      {/* Header: project + client (editable) */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16 }}>
        <div style={{ flex: 1 }}>
          {editing === "project" ? (
            <div>
              <input type="text" value={editValue} onChange={e => setEditValue(e.target.value)} style={{ ...editInputStyle, fontSize: 16, fontWeight: 700 }} />
              <div style={{ display: "flex", gap: 8 }}>
                <button onClick={cancelEdit} style={cancelBtnStyle}>Cancelar</button>
                <button onClick={() => saveField("project", editValue)} disabled={saving} style={{ ...saveBtnStyle, opacity: saving ? 0.7 : 1 }}>{saving ? "..." : "Guardar"}</button>
              </div>
            </div>
          ) : (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <h2 style={{ fontSize: 17, fontWeight: 700, color: brandGreen, margin: 0 }}>{data.project}</h2>
              {canEdit && <button onClick={() => startEdit("project", data.project)} style={editBtnStyle}>Editar</button>}
            </div>
          )}
          {editing === "client" ? (
            <div style={{ marginTop: 6 }}>
              <input type="text" value={editValue} onChange={e => setEditValue(e.target.value)} style={editInputStyle} />
              <div style={{ display: "flex", gap: 8 }}>
                <button onClick={cancelEdit} style={cancelBtnStyle}>Cancelar</button>
                <button onClick={() => saveField("client", editValue)} disabled={saving} style={{ ...saveBtnStyle, opacity: saving ? 0.7 : 1 }}>{saving ? "..." : "Guardar"}</button>
              </div>
            </div>
          ) : (
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 4 }}>
              <p style={{ fontSize: 13, color: "#64748b", margin: 0 }}>{data.client}</p>
              {canEdit && <button onClick={() => startEdit("client", data.client)} style={editBtnStyle}>Editar</button>}
            </div>
          )}
        </div>
        <div style={{ display: "flex", gap: 6, flexDirection: "column", alignItems: "flex-end" }}>
          <DispatchTypeBadge type={data.dispatch_type} />
          <StatusBadge status={data.status} />
        </div>
      </div>

      {/* Info fields */}
      <div style={{ background: "#f8fafc", borderRadius: 10, padding: 14, marginBottom: 16 }}>
        <InlineField label="Tipo" field="dispatch_type" value={data.dispatch_type || "entrega"} displayValue={{ entrega: "Entrega", recogida: "Recogida", retiro: "Retiro en Almacén" }[data.dispatch_type || "entrega"]} type="select-type" alwaysEditable={true} />
        <InlineField label="SO#" field="so_number" value={data.so_number} />
        <InlineField label="Empresa" field="company" value={data.company || ""} displayValue={data.company || "—"} type="select-company" alwaysEditable={true} />
        <InlineField label="Conductor" field="driver" value={data.driver} displayValue={data.driver === "Subcontratista" ? data.subcontractor_name || "Subcontratista" : data.driver} type="select-driver" />
        <InlineField label="Fecha" field="date" value={data.date} displayValue={formatDate(data.date)} type="date" />
        <InlineField label="Zona de destino" field="destination_zone" value={data.destination_zone || "Santo Domingo"} type="select-zone" />
      </div>

      {/* Access pass (always editable, even post-delivery) */}
      {(data.destination_zone === "Este (Cap Cana / Casa de Campo / Punta Cana)") && (
        <div style={{ marginBottom: 14 }}>
          <p style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 }}>Pase de acceso</p>
          {data.access_pass_url && (
            <img src={data.access_pass_url} alt="Pase de acceso" style={{ width: "100%", borderRadius: 8, border: "1px solid #e2e8f0", marginBottom: 8 }} />
          )}
          <label style={{ display: "block", padding: "9px 14px", borderRadius: 9, border: "1.5px dashed #e2e8f0", background: "white", cursor: uploadingAccessPass ? "default" : "pointer", fontSize: 13, color: "#64748b", textAlign: "center" }}>
            <input type="file" accept="image/*" style={{ display: "none" }} onChange={uploadDetailAccessPass} disabled={uploadingAccessPass} />
            {uploadingAccessPass ? "Subiendo..." : data.access_pass_url ? "📎 Reemplazar pase" : "📎 Subir pase de acceso"}
          </label>
        </div>
      )}

      {/* Locations (editable) */}
      <div style={{ marginBottom: 14 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
          <p style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", margin: 0 }}>Ubicaciones</p>
          {canEdit && editing !== "locations" && <button onClick={() => startEdit("locations")} style={editBtnStyle}>Editar</button>}
        </div>
        {editing === "locations" ? (
          <div>
            <LocationsBuilder locations={editLocations} onChange={setEditLocations} />
            <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
              <button onClick={cancelEdit} style={cancelBtnStyle}>Cancelar</button>
              <button onClick={() => saveField("locations", editLocations)} disabled={saving} style={{ ...saveBtnStyle, opacity: saving ? 0.7 : 1 }}>{saving ? "..." : "Guardar"}</button>
            </div>
          </div>
        ) : locs.length > 0 ? (
          locs.map((l, i) => (
            <div key={i} style={{ background: "#f8fafc", borderRadius: 8, padding: "8px 10px", marginBottom: 6, fontSize: 13 }}>
              <span style={{ fontWeight: 600, color: brandGreen }}>{l.floor}</span>
              {l.address && <div style={{ color: "#64748b", fontSize: 12 }}>{l.address}</div>}
              {l.contact && <div style={{ color: "#64748b", fontSize: 12 }}>👤 {l.contact}</div>}
              {l.notes && <div style={{ color: "#92400e", fontSize: 12 }}>⚠️ {l.notes}</div>}
            </div>
          ))
        ) : <div style={{ fontSize: 13, color: "#94a3b8" }}>Sin ubicaciones</div>}
      </div>

      {/* Materials (editable) */}
      <div style={{ marginBottom: 14 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
          <p style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", margin: 0 }}>Materiales</p>
          {canEdit && editing !== "materials" && <button onClick={() => startEdit("materials")} style={editBtnStyle}>Editar</button>}
        </div>
        {editing === "materials" ? (
          <div>
            <MaterialsBuilder materials={editMaterials} onChange={setEditMaterials} />
            <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
              <button onClick={cancelEdit} style={cancelBtnStyle}>Cancelar</button>
              <button onClick={() => saveField("materials", editMaterials)} disabled={saving} style={{ ...saveBtnStyle, opacity: saving ? 0.7 : 1 }}>{saving ? "..." : "Guardar"}</button>
            </div>
          </div>
        ) : mats.length > 0 ? (
          mats.map((m, i) => (
            <div key={i} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, padding: "5px 0", borderBottom: "1px solid #f1f5f9" }}>
              <span style={{ color: "#374151" }}>{m.name}</span>
              <span style={{ fontWeight: 600, color: brandGreen }}>{m.quantity} {m.unit}</span>
            </div>
          ))
        ) : <div style={{ fontSize: 13, color: "#94a3b8" }}>Sin materiales</div>}
      </div>

      {/* Special notes (editable) */}
      {(data.special_notes || canEdit) && (
        <div style={{ marginBottom: 14 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
            <p style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", margin: 0 }}>Notas especiales</p>
            {canEdit && editing !== "special_notes" && <button onClick={() => startEdit("special_notes", data.special_notes || "")} style={editBtnStyle}>{data.special_notes ? "Editar" : "Agregar"}</button>}
          </div>
          {editing === "special_notes" ? (
            <div>
              <textarea value={editValue} onChange={e => setEditValue(e.target.value)} rows={3} placeholder="Instrucciones adicionales..." style={{ ...editInputStyle, resize: "vertical" }} />
              <div style={{ display: "flex", gap: 8 }}>
                <button onClick={cancelEdit} style={cancelBtnStyle}>Cancelar</button>
                <button onClick={() => saveField("special_notes", editValue)} disabled={saving} style={{ ...saveBtnStyle, opacity: saving ? 0.7 : 1 }}>{saving ? "..." : "Guardar"}</button>
              </div>
            </div>
          ) : data.special_notes ? (
            <div style={{ fontSize: 12, color: "#92400e", background: "#fff7ed", border: "1px solid #fed7aa", borderRadius: 8, padding: "8px 10px" }}>⚠️ {data.special_notes}</div>
          ) : null}
        </div>
      )}

      {/* Delivery record (read-only, shown when entregado or problema) */}
      {(data.status === "entregado" || data.status === "problema") && (
        <div>
          <p style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 }}>Registro de Entrega</p>
          <div style={{ fontSize: 13, color: "#475569", marginBottom: 10 }}>
            <strong>Entregado:</strong> {formatTime(data.completed_at)}<br />
            <strong>Recibido por:</strong> {data.recipient_name}
            {data.delivery_notes && <><br /><strong>Notas:</strong> {data.delivery_notes}</>}
          </div>
          {deliveryMats.length > 0 && (
            <div style={{ marginBottom: 12 }}>
              <p style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>Checklist conductor</p>
              {deliveryMats.map((m, i) => (
                <div key={i} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, padding: "4px 0" }}>
                  <span style={{ color: m.confirmed ? "#166534" : "#9f1239" }}>{m.confirmed ? "✓" : "✗"} {m.name}</span>
                  <span style={{ color: "#64748b" }}>{m.actual_quantity} {m.unit}</span>
                </div>
              ))}
            </div>
          )}
          {data.signature_data && (
            <div style={{ marginBottom: 12 }}>
              <p style={{ fontSize: 11, color: "#94a3b8", marginBottom: 4 }}>Firma:</p>
              <img src={data.signature_data} alt="firma" style={{ border: "1px solid #e2e8f0", borderRadius: 8, maxWidth: "100%" }} />
            </div>
          )}
          {(() => {
            const ap = safeParse(data.arrival_photos, { camion: [], fachada: [], deposito: [] });
            const allArrival = [...(ap.camion || []), ...(ap.fachada || []), ...(ap.deposito || []), ...(ap.autorizacion || [])];
            const dp = safeParse(data.delivery_photos, []);
            const cp = safeParse(data.conduce_photos, []);
            const photoGrid = (urls) => (
              <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 8 }}>
                {urls.map((url, i) => <img key={i} src={url} alt="" style={{ width: "100%", borderRadius: 8, border: "1px solid #e2e8f0", aspectRatio: "4/3", objectFit: "cover" }} />)}
              </div>
            );
            return (
              <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                {allArrival.length > 0 && <div><p style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>Fotos de llegada</p>{photoGrid(allArrival)}</div>}
                {dp.length > 0 && <div><p style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>Fotos de entrega</p>{photoGrid(dp)}</div>}
                {cp.length > 0 && <div><p style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>Conduce firmado</p>{photoGrid(cp)}</div>}
              </div>
            );
          })()}
        </div>
      )}

      {/* Problem note (read-only) */}
      {data.status === "problema" && data.delivery_notes && (
        <div style={{ background: "#fff1f2", border: "1px solid #fecdd3", borderRadius: 10, padding: 12, fontSize: 13, color: "#9f1239" }}>
          ⚠️ <strong>Problema:</strong> {data.delivery_notes}
        </div>
      )}

      {/* Override: mark problema as entregado */}
      {data.status === "problema" && (
        <div style={{ marginTop: 12 }}>
          <button onClick={async () => {
            try {
              await supabase.query("dispatches", "PATCH", { status: "entregado" }, `?id=eq.${data.id}`);
              const updated = await supabase.query("dispatches", "GET", null, `?id=eq.${data.id}`);
              if (updated[0]) setData(updated[0]);
            } catch (e) { alert("Error: " + e.message); }
          }} style={{ width: "100%", padding: "10px", borderRadius: 9, background: "none", color: "#166534", fontSize: 13, fontWeight: 600, border: "1px solid #bbf7d0", cursor: "pointer" }}>
            ✓ Marcar como Entregado
          </button>
        </div>
      )}

      {/* Manual completion */}
      {canEdit && (
        <div style={{ marginTop: 16, borderTop: "1px solid #e2e8f0", paddingTop: 16 }}>
          {!showManualForm ? (
            <button onClick={() => setShowManualForm(true)} style={{ width: "100%", padding: "10px", borderRadius: 9, background: "none", color: "#166534", fontSize: 13, fontWeight: 600, border: "1px solid #bbf7d0", cursor: "pointer" }}>
              📋 Completar manualmente
            </button>
          ) : (
            <div>
              <p style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 14, marginTop: 0 }}>Completar manualmente</p>
              <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
                <div style={{ flex: 2 }}>
                  <label style={labelStyle}>Fecha de entrega</label>
                  <input type="date" value={manualDate} onChange={e => setManualDate(e.target.value)} style={inputStyle} />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={labelStyle}>Hora</label>
                  <input type="time" value={manualTime} onChange={e => setManualTime(e.target.value)} style={inputStyle} />
                </div>
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={labelStyle}>Recibido por (opcional)</label>
                <input type="text" value={manualRecipient} onChange={e => setManualRecipient(e.target.value)} placeholder="Nombre del receptor" style={inputStyle} />
              </div>
              {[["delivery", "📷 Fotos de entrega"], ["conduce", "📄 Conduce firmado"]].map(([cat, lbl]) => (
                <div key={cat} style={{ marginBottom: 14 }}>
                  <label style={labelStyle}>{lbl} (opcional)</label>
                  {manualPhotos[cat].length > 0 && (
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 6, marginBottom: 8 }}>
                      {manualPhotos[cat].map((url, i) => (
                        <div key={url} style={{ position: "relative" }}>
                          <img src={url} alt="" style={{ width: "100%", aspectRatio: "1", objectFit: "cover", borderRadius: 8, border: "1px solid #e2e8f0" }} />
                          <button onClick={() => removeManualPhoto(cat, i)} style={{ position: "absolute", top: 3, right: 3, width: 18, height: 18, borderRadius: "50%", background: "#f43f5e", border: "none", color: "white", fontSize: 11, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
                        </div>
                      ))}
                    </div>
                  )}
                  <label style={{ display: "block", padding: "10px 14px", borderRadius: 9, border: "1.5px dashed #e2e8f0", background: "white", cursor: manualUploading === cat ? "default" : "pointer", fontSize: 13, color: "#64748b", textAlign: "center" }}>
                    <input type="file" accept="image/*" style={{ display: "none" }} onChange={e => uploadManualPhoto(e, cat)} disabled={!!manualUploading} />
                    {manualUploading === cat ? "Subiendo..." : `+ Agregar foto`}
                  </label>
                </div>
              ))}
              <div style={{ display: "flex", gap: 8 }}>
                <button onClick={() => setShowManualForm(false)} style={{ flex: 1, padding: "10px", borderRadius: 9, border: "0.5px solid #e2e8f0", background: "white", fontSize: 13, color: "#64748b", cursor: "pointer" }}>Cancelar</button>
                <button onClick={handleManualComplete} disabled={manualSubmitting || !!manualUploading} style={{ flex: 2, padding: "10px", borderRadius: 9, background: "#059669", color: "white", fontSize: 13, fontWeight: 600, border: "none", cursor: "pointer", opacity: (manualSubmitting || !!manualUploading) ? 0.7 : 1 }}>
                  {manualSubmitting ? "Guardando..." : "✓ Marcar como Entregado"}
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Cancel button */}
      {data.status !== "cancelado" && data.status !== "entregado" && (
        <div style={{ marginTop: 16, borderTop: "1px solid #e2e8f0", paddingTop: 16 }}>
          <button onClick={async () => {
            if (window.confirm("¿Cancelar este despacho? El registro se mantendrá en el historial.")) {
              try {
                await supabase.query("dispatches", "PATCH", { status: "cancelado" }, `?id=eq.${data.id}`);
                const updated = await supabase.query("dispatches", "GET", null, `?id=eq.${data.id}`);
                if (updated[0]) setData(updated[0]);
              } catch (e) { alert("Error: " + e.message); }
            }
          }} style={{ width: "100%", padding: "10px", borderRadius: 9, background: "none", color: "#9f1239", fontSize: 13, fontWeight: 600, border: "1px solid #fecdd3", cursor: "pointer" }}>
            Cancelar despacho
          </button>
        </div>
      )}
    </div>
  );
}

function WeekView({ onStart, onView }) {
  const [weekDispatches, setWeekDispatches] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const monday = new Date();
        monday.setDate(monday.getDate() - monday.getDay() + 1);
        const endDate = new Date(monday);
        endDate.setDate(monday.getDate() + 13);
        const monStr = monday.toISOString().split("T")[0];
        const endStr = endDate.toISOString().split("T")[0];
        const data = await supabase.query("dispatches", "GET", null, `?date=gte.${monStr}&date=lte.${endStr}&order=date.asc`);
        setWeekDispatches(data);
      } catch (e) { console.error(e); }
    };
    load();
  }, []);

  const today = todayStr();
  const monday = new Date();
  monday.setDate(monday.getDate() - monday.getDay() + 1);

  const days = Array.from({ length: 14 }, (_, i) => {
    const d = new Date(monday);
    d.setDate(monday.getDate() + i);
    const dateStr = d.toISOString().split("T")[0];
    const isToday = dateStr === today;
    const isPast = dateStr < today;
    const dispatches = weekDispatches.filter(x => x.date === dateStr);
    const dayName = d.toLocaleDateString("es-DO", { weekday: "short" }).replace(".", "");
    const dayNum = d.getDate();
    return { dateStr, isToday, isPast, dispatches, dayName, dayNum };
  });

  const todayDispatches = weekDispatches.filter(d => d.date === today);
  const futureDispatches = weekDispatches.filter(d => d.date > today);
  const todayCount = todayDispatches.length;

  return (
    <div>
      {/* Header */}
      <div style={{ background: brandGreen, borderRadius: 14, padding: "16px 16px 12px", marginBottom: 16 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
          <div>
            <p style={{ fontSize: 15, fontWeight: 600, color: "white", margin: 0 }}>Buenos dias, Joel</p>
            <p style={{ fontSize: 11, color: "rgba(255,255,255,0.5)", margin: "4px 0 0" }}>
              {new Date().toLocaleDateString("es-DO", { weekday: "long", day: "numeric", month: "long" })}
            </p>
          </div>
          {todayCount > 0 && (
            <div style={{ background: "rgba(255,255,255,0.12)", borderRadius: 20, padding: "4px 12px" }}>
              <span style={{ fontSize: 12, color: "white", fontWeight: 500 }}>{todayCount} entrega{todayCount !== 1 ? "s" : ""} hoy</span>
            </div>
          )}
        </div>

        {/* Horizontal date strip */}
        <div style={{ display: "flex", gap: 2, overflowX: "auto", margin: "0 -4px", padding: "0 4px" }}>
          {days.map(({ dateStr, isToday, isPast, dispatches, dayName, dayNum }) => (
            <div key={dateStr} style={{
              flexShrink: 0, padding: "6px 8px", borderRadius: 8, textAlign: "center", minWidth: 38,
              background: isToday ? "rgba(255,255,255,0.2)" : "transparent",
              opacity: isPast ? 0.35 : 1,
            }}>
              <p style={{ fontSize: 9, color: "rgba(255,255,255,0.6)", textTransform: "uppercase", letterSpacing: "0.04em", margin: 0 }}>{dayName}</p>
              <p style={{ fontSize: 14, color: "white", fontWeight: isToday ? 700 : 500, margin: "2px 0 0" }}>{dayNum}</p>
              {dispatches.length > 0 && (
                <div style={{ display: "flex", gap: 2, justifyContent: "center", marginTop: 3 }}>
                  {dispatches.length <= 3
                    ? dispatches.map((_, i) => <div key={i} style={{ width: 4, height: 4, borderRadius: "50%", background: isPast ? "rgba(255,255,255,0.4)" : "#22c55e" }} />)
                    : <div style={{ width: 4, height: 4, borderRadius: "50%", background: isPast ? "rgba(255,255,255,0.4)" : "#22c55e" }} />
                  }
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Today's dispatches */}
      {todayCount > 0 && (
        <div style={{ marginBottom: 20 }}>
          <p style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 10 }}>
            Hoy — {todayCount} entrega{todayCount !== 1 ? "s" : ""}
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {todayDispatches.map(d => {
              const dMats = safeParse(d.materials_manifest, []);
              const dLocs = safeParse(d.locations, []);
              const isDone = d.status === "entregado" || d.status === "problema";
              const isActive = d.status === "pendiente" || d.status === "en_ruta";

              const isEste = d.destination_zone === "Este (Cap Cana / Casa de Campo / Punta Cana)";

              const dispType = d.dispatch_type || "entrega";
              const startLabel = { entrega: "Iniciar entrega →", recogida: "Iniciar recogida →", retiro: "Iniciar retiro →" }[dispType];
              const continueLabel = { entrega: "Continuar entrega →", recogida: "Continuar recogida →", retiro: "Continuar retiro →" }[dispType];

              if (isDone) {
                return (
                  <div key={d.id} style={{ background: "white", border: "1px solid #e2e8f0", borderRadius: 12, padding: "12px 14px", opacity: 0.6 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div>
                        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                          <span style={{ fontSize: 14, fontWeight: 500, color: "#94a3b8" }}>{d.project}</span>
                          <DispatchTypeBadge type={dispType} />
                          {isEste && <span style={{ fontSize: 9, fontWeight: 700, background: "#f97316", color: "white", padding: "1px 6px", borderRadius: 8, flexShrink: 0 }}>ESTE</span>}
                        </div>
                        <div style={{ fontSize: 11, color: "#cbd5e1", marginTop: 2 }}>{d.client} · {d.so_number}</div>
                      </div>
                      <span style={{ fontSize: 10, fontWeight: 600, background: d.status === "problema" ? "#fff1f2" : "#dcfce7", color: d.status === "problema" ? "#9f1239" : "#166534", padding: "3px 8px", borderRadius: 12 }}>
                        {d.status === "problema" ? "Problema" : "Completado"}
                      </span>
                    </div>
                  </div>
                );
              }

              return (
                <div key={d.id} style={{ background: "white", border: d.status === "en_ruta" ? "2px solid #eab308" : `2px solid ${brandGreen}`, borderRadius: 12, padding: 14 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 6 }}>
                    <div>
                      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        <div style={{ fontSize: 14, fontWeight: 600, color: brandGreen }}>{d.project}</div>
                        <DispatchTypeBadge type={dispType} />
                      </div>
                      <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>{d.client} · {d.so_number}</div>
                    </div>
                    {d.status === "en_ruta" && <span style={{ fontSize: 10, fontWeight: 600, background: "#fef9c3", color: "#854d0e", padding: "3px 8px", borderRadius: 12 }}>En ruta</span>}
                  </div>
                  {isEste && <div style={{ background: "#fff7ed", border: "1px solid #fed7aa", borderRadius: 8, padding: "6px 10px", marginBottom: 8, fontSize: 12, fontWeight: 600, color: "#92400e" }}>🌴 Entrega Este — Cap Cana / Casa de Campo / Punta Cana</div>}
                  {dLocs.length > 0 && (
                    <div style={{ fontSize: 11, color: "#64748b", marginBottom: 4 }}>
                      📍 {dLocs[0].floor}{dLocs.length > 1 ? ` +${dLocs.length - 1} más` : ""}{dLocs[0].contact ? ` · ${dLocs[0].contact}` : ""}
                    </div>
                  )}
                  {dMats.length > 0 && (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginTop: 6, marginBottom: 4 }}>
                      {dMats.map((m, i) => <span key={i} style={{ fontSize: 10, color: "#475569", background: "#f1f5f9", borderRadius: 5, padding: "2px 7px" }}>{m.quantity} {m.unit} {m.name}</span>)}
                    </div>
                  )}
                  {d.special_notes && <div style={{ fontSize: 11, color: "#92400e", background: "#fff7ed", border: "1px solid #fed7aa", borderRadius: 6, padding: "6px 8px", marginTop: 8 }}>⚠️ {d.special_notes}</div>}
                  {isActive && (
                    <button onClick={() => onStart(d)} style={{
                      width: "100%", borderRadius: 8, padding: "10px", fontSize: 13, fontWeight: 600, cursor: "pointer", marginTop: 10, border: "none",
                      background: d.status === "en_ruta" ? "#f0fdf4" : brandGreen,
                      color: d.status === "en_ruta" ? "#166534" : "white",
                      ...(d.status === "en_ruta" ? { border: "1.5px solid #bbf7d0" } : {}),
                    }}>
                      {d.status === "en_ruta" ? continueLabel : startLabel}
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {todayCount === 0 && (
        <div style={{ textAlign: "center", padding: "30px 16px", background: "white", borderRadius: 12, border: "1px solid #e2e8f0", marginBottom: 20 }}>
          <div style={{ fontSize: 28, marginBottom: 8 }}>📦</div>
          <p style={{ color: "#94a3b8", fontSize: 14, margin: 0 }}>No hay entregas hoy</p>
        </div>
      )}

      {/* Future dispatches */}
      {futureDispatches.length > 0 && (
        <div>
          <p style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 10 }}>
            Proximas entregas
          </p>
          <div style={{ background: "white", borderRadius: 12, border: "1px solid #e2e8f0", overflow: "hidden" }}>
            {futureDispatches.map((d, i) => {
              const dMats = safeParse(d.materials_manifest, []);
              const dLocs = safeParse(d.locations, []);
              const dateLabel = new Date(d.date + "T00:00:00").toLocaleDateString("es-DO", { weekday: "short", day: "numeric", month: "short" });
              const totalItems = dMats.reduce((sum, m) => sum + (m.quantity || 0), 0);
              const itemSummary = dMats.length > 0
                ? (dMats.length === 1 ? `${totalItems} ${dMats[0].unit} ${dMats[0].name}` : `${dMats.length} materiales`)
                : "";
              const fIsEste = d.destination_zone === "Este (Cap Cana / Casa de Campo / Punta Cana)";
              return (
                <div key={d.id} onClick={() => onView(d)} style={{
                  padding: "12px 14px", cursor: "pointer",
                  borderBottom: i < futureDispatches.length - 1 ? "1px solid #f1f5f9" : "none",
                  display: "flex", justifyContent: "space-between", alignItems: "center",
                }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 6, overflow: "hidden", flexWrap: "wrap" }}>
                      <span style={{ fontSize: 13, fontWeight: 500, color: brandGreen, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{d.project}</span>
                      <DispatchTypeBadge type={d.dispatch_type} />
                      {fIsEste && <span style={{ fontSize: 9, fontWeight: 700, background: "#f97316", color: "white", padding: "1px 6px", borderRadius: 8, flexShrink: 0 }}>ESTE</span>}
                    </div>
                    <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 2 }}>
                      {dateLabel}{dLocs.length > 0 ? ` · 📍 ${dLocs[0].floor}` : ""}{itemSummary ? ` · ${itemSummary}` : ""}
                    </div>
                  </div>
                  <span style={{ fontSize: 14, color: "#cbd5e1", flexShrink: 0, marginLeft: 8 }}>›</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

function MultiPhotoCapture({ photos, category, isDelivery, onCapture, onRemove }) {
  const fileRef = useRef(null);
  const galleryRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const canAdd = photos.length < 6;

  const handleFile = async (e) => {
    const file = e.target.files[0];
    e.target.value = ""; // Reset so the same file can be selected again
    if (!file) return;
    setUploading(true);
    try {
      await onCapture(file, category, isDelivery);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <input ref={fileRef} type="file" accept="image/*" capture="environment" style={{ display: "none" }} onChange={handleFile} />
      <input ref={galleryRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handleFile} />
      {photos.length > 0 && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 6, marginBottom: 8 }}>
          {photos.map((url, i) => (
            <div key={url} style={{ position: "relative" }}>
              <img src={url} alt="" style={{ width: "100%", aspectRatio: "1", objectFit: "cover", borderRadius: 8, border: "1px solid #e2e8f0" }} />
              <button onClick={() => onRemove(category, i, isDelivery)} style={{ position: "absolute", top: 3, right: 3, width: 18, height: 18, borderRadius: "50%", background: "#f43f5e", border: "none", color: "white", fontSize: 11, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", lineHeight: 1 }}>×</button>
            </div>
          ))}
        </div>
      )}
      {uploading && (
        <div style={{ textAlign: "center", padding: "12px", marginBottom: 8, background: "#f8fafc", borderRadius: 10, border: "1px solid #e2e8f0" }}>
          <p style={{ fontSize: 13, color: "#64748b", margin: 0 }}>Subiendo foto...</p>
        </div>
      )}
      {canAdd && !uploading && (
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={() => fileRef.current.click()} style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 6, padding: "10px", borderRadius: 10, border: "1.5px solid #e2e8f0", background: "white", cursor: "pointer", fontSize: 13, color: "#475569", fontWeight: 500 }}>📷 Cámara</button>
          <button onClick={() => galleryRef.current.click()} style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 6, padding: "10px", borderRadius: 10, border: "1.5px solid #e2e8f0", background: "white", cursor: "pointer", fontSize: 13, color: "#475569", fontWeight: 500 }}>🖼️ Galería</button>
        </div>
      )}
      {!canAdd && <p style={{ fontSize: 11, color: "#94a3b8", margin: "4px 0 0" }}>Máximo 6 fotos por requisito</p>}
      <p style={{ fontSize: 11, color: "#94a3b8", margin: "4px 0 0" }}>{photos.length}/6 fotos</p>
    </div>
  );
}

function DriverView() {
  const [selected, setSelected] = useState(null);
  const [step, setStep] = useState(0);
  const [viewingDispatch, setViewingDispatch] = useState(null);
  const [arrivalPhotos, setArrivalPhotos] = useState({ camion: [], fachada: [], deposito: [] });
  const [deliveryPhotos, setDeliveryPhotos] = useState([]);
  const [conducePhotos, setConducePhotos] = useState([]);
  const [materialChecklist, setMaterialChecklist] = useState([]);
  const [hasIssue, setHasIssue] = useState(false);
  const [deliveryNotes, setDeliveryNotes] = useState("");
  const [recipientName, setRecipientName] = useState("");
  const [signature, setSignature] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [historyDispatches, setHistoryDispatches] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historySearch, setHistorySearch] = useState("");

  useEffect(() => {
    if (!showHistory) return;
    const loadHistory = async () => {
      setHistoryLoading(true);
      try {
        const data = await supabase.query("dispatches", "GET", null, `?status=in.(entregado,problema)&order=created_at.desc`);
        setHistoryDispatches(data);
      } catch (e) { console.error(e); }
      setHistoryLoading(false);
    };
    loadHistory();
  }, [showHistory]);

  const startDelivery = async (d) => {
    try {
      const fresh = await supabase.query("dispatches", "GET", null, `?id=eq.${d.id}`);
      const dispatch = fresh[0] || d;
      
      setSelected(dispatch);
      const mats = safeParse(dispatch.materials_manifest, []);
      setMaterialChecklist(mats.map(m => ({ ...m, confirmed: false, actual_quantity: m.quantity })));

      if (dispatch.status === "en_ruta") {
        const savedStep = dispatch.current_step || 1;
        const savedArrival = safeParse(dispatch.arrival_photos, { camion: [], fachada: [], deposito: [] });
        const savedDelivery = safeParse(dispatch.delivery_photos, []);
        const savedConduce = safeParse(dispatch.conduce_photos, []);
        setArrivalPhotos(savedArrival);
        setDeliveryPhotos(savedDelivery);
        setConducePhotos(savedConduce);
        setStep(savedStep);
      } else {
        setStep(1);
        await supabase.query("dispatches", "PATCH", { status: "en_ruta", current_step: 1 }, `?id=eq.${dispatch.id}`);
      }
    } catch (e) {
      console.error("startDelivery error:", e);
      alert("Error iniciando entrega: " + e.message);
    }
  };

  const saveProgress = async (newStep, newArrivalPhotos, newDeliveryPhotos) => {
    try {
      await supabase.query("dispatches", "PATCH", {
        current_step: newStep,
        arrival_photos: newArrivalPhotos || arrivalPhotos,
        delivery_photos: newDeliveryPhotos || deliveryPhotos,
      }, `?id=eq.${selected.id}`);
    } catch (e) { console.error(e); }
  };

  const capturePhoto = async (file, category, isDelivery = false) => {
    if (!file) return;
    try {
      const ts = Date.now();
      const projectFolder = selected.project.replace(/[^a-zA-Z0-9]/g, "_");
      const soFolder = selected.so_number.replace(/[^a-zA-Z0-9]/g, "_");
      const path = `${projectFolder}/${soFolder}/${isDelivery ? "entrega" : category}-${ts}.jpg`;
      const url = await supabase.uploadPhoto(file, path);

      if (isDelivery) {
        const updated = [...deliveryPhotos, url];
        setDeliveryPhotos(updated);
        await saveProgress(step, null, updated);
      } else {
        const updated = { ...arrivalPhotos, [category]: [...(arrivalPhotos[category] || []), url] };
        setArrivalPhotos(updated);
        await saveProgress(step, updated, null);
      }
    } catch (e) { alert("Error subiendo foto: " + e.message); }
  };

  const removePhoto = async (category, index, isDelivery = false) => {
    if (isDelivery) {
      const updated = deliveryPhotos.filter((_, i) => i !== index);
      setDeliveryPhotos(updated);
      await saveProgress(step, null, updated);
    } else {
      const updated = { ...arrivalPhotos, [category]: arrivalPhotos[category].filter((_, i) => i !== index) };
      setArrivalPhotos(updated);
      await saveProgress(step, updated, null);
    }
  };

  const captureConducePhoto = async (file) => {
    if (!file) return;
    try {
      const projectFolder = selected.project.replace(/[^a-zA-Z0-9]/g, "_");
      const soFolder = selected.so_number.replace(/[^a-zA-Z0-9]/g, "_");
      const path = `${projectFolder}/${soFolder}/conduce-${Date.now()}.jpg`;
      const url = await supabase.uploadPhoto(file, path);
      const updated = [...conducePhotos, url];
      setConducePhotos(updated);
      await supabase.query("dispatches", "PATCH", { conduce_photos: updated }, `?id=eq.${selected.id}`);
    } catch (e) { alert("Error subiendo foto: " + e.message); }
  };

  const removeConducePhoto = async (category, index) => {
    const updated = conducePhotos.filter((_, i) => i !== index);
    setConducePhotos(updated);
    await supabase.query("dispatches", "PATCH", { conduce_photos: updated }, `?id=eq.${selected.id}`);
  };

  const goToStep = async (newStep) => {
    setStep(newStep);
    await saveProgress(newStep, null, null);
  };

  const toggleMaterial = (i) => { const u = [...materialChecklist]; u[i] = { ...u[i], confirmed: !u[i].confirmed }; setMaterialChecklist(u); };
  const updateMaterialQty = (i, qty) => { const u = [...materialChecklist]; u[i] = { ...u[i], actual_quantity: parseInt(qty) || 0 }; setMaterialChecklist(u); };

  const handleSubmit = async () => {
    if (!recipientName || !signature) return;
    setSubmitting(true);
    try {
      await supabase.query("dispatches", "PATCH", {
        status: hasIssue ? "problema" : "entregado",
        completed_at: new Date().toISOString(),
        delivery_notes: deliveryNotes || null,
        recipient_name: recipientName,
        signature_data: signature,
        delivery_materials: JSON.stringify(materialChecklist),
        conduce_photos: conducePhotos,
        current_step: 4,
      }, `?id=eq.${selected.id}`);
      setStep(5);
    } catch (e) { alert("Error enviando: " + e.message); }
    setSubmitting(false);
  };

  const reset = () => {
    setSelected(null); setStep(0);
    setArrivalPhotos({ camion: [], fachada: [], deposito: [], autorizacion: [] });
    setDeliveryPhotos([]);
    setConducePhotos([]);
    setMaterialChecklist([]); setHasIssue(false);
    setDeliveryNotes(""); setRecipientName(""); setSignature(null);
  };

  const locs = safeParse(selected?.locations, []);
  const mats = safeParse(selected?.materials_manifest, []);

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc", fontFamily: "'DM Sans', 'Helvetica Neue', sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
      <div style={{ position: "sticky", top: 0, zIndex: 50, background: "rgba(248,250,252,0.95)", backdropFilter: "blur(8px)", borderBottom: "1px solid #e2e8f0" }}>
        <div style={{ maxWidth: 480, margin: "0 auto", padding: "12px 16px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 32, height: 32, borderRadius: 8, background: brandGreen, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
            </div>
            <div><div style={{ fontSize: 13, fontWeight: 700, color: brandGreen, letterSpacing: "0.12em" }}>CONTIDECO</div><div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 500, letterSpacing: "0.1em" }}>CONDUCTOR</div></div>
          </div>
          {step === 1 && <button onClick={reset} style={{ fontSize: 12, color: "#64748b", background: "none", border: "none", cursor: "pointer" }}>← Atrás</button>}
          {step > 1 && step < 5 && <button onClick={() => goToStep(step - 1)} style={{ fontSize: 12, color: "#64748b", background: "none", border: "none", cursor: "pointer" }}>← Atrás</button>}
          {viewingDispatch && step === 0 && <button onClick={() => setViewingDispatch(null)} style={{ fontSize: 12, color: "#64748b", background: "none", border: "none", cursor: "pointer" }}>← Atrás</button>}
          {showHistory && step === 0 && <button onClick={() => selectedHistory ? setSelectedHistory(null) : setShowHistory(false)} style={{ fontSize: 12, color: "#64748b", background: "none", border: "none", cursor: "pointer" }}>← Atrás</button>}
        </div>
      </div>

      <div style={{ maxWidth: 480, margin: "0 auto", padding: "20px 16px" }}>

      {step === 0 && !viewingDispatch && !showHistory && (
  <div>
    <WeekView onStart={startDelivery} onView={setViewingDispatch} />
    <button onClick={() => setShowHistory(true)} style={{ width: "100%", marginTop: 16, padding: "11px", borderRadius: 10, border: "1px solid #e2e8f0", background: "white", fontSize: 13, fontWeight: 500, color: "#64748b", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
      📋 Mis entregas
    </button>
  </div>
)}

      {step === 0 && !viewingDispatch && showHistory && !selectedHistory && (
  <div>
    <h2 style={{ fontSize: 17, fontWeight: 700, color: brandGreen, marginTop: 0, marginBottom: 12 }}>Mis entregas</h2>
    <input type="text" value={historySearch} onChange={e => setHistorySearch(e.target.value)}
      placeholder="Buscar por cliente, proyecto, SO#, receptor..."
      style={{ ...inputStyle, marginBottom: 16, fontSize: 13 }} />
    {historyLoading ? (
      <div style={{ textAlign: "center", padding: 40, color: "#94a3b8" }}>Cargando...</div>
    ) : (() => {
      const q = historySearch.toLowerCase();
      const filtered = historyDispatches.filter(d =>
        !q ||
        d.project?.toLowerCase().includes(q) ||
        d.client?.toLowerCase().includes(q) ||
        d.so_number?.toLowerCase().includes(q) ||
        d.recipient_name?.toLowerCase().includes(q) ||
        d.date?.includes(q)
      );
      return filtered.length === 0 ? (
        <div style={{ textAlign: "center", padding: "30px 16px", background: "white", borderRadius: 12, border: "1px solid #e2e8f0" }}>
          <div style={{ fontSize: 28, marginBottom: 8 }}>📦</div>
          <p style={{ color: "#94a3b8", fontSize: 14, margin: 0 }}>{historySearch ? "Sin resultados" : "No hay entregas registradas"}</p>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {filtered.map(d => {
            const dMats = safeParse(d.materials_manifest, []);
            return (
              <div key={d.id} onClick={() => setSelectedHistory(d)} style={{ background: "white", border: "1px solid #e2e8f0", borderRadius: 12, padding: "12px 14px", cursor: "pointer" }}
                onTouchStart={e => e.currentTarget.style.background = "#f8fafc"} onTouchEnd={e => e.currentTarget.style.background = "white"}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 4 }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 2 }}>
                      <div style={{ fontSize: 14, fontWeight: 600, color: brandGreen, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{d.project}</div>
                      <DispatchTypeBadge type={d.dispatch_type} />
                    </div>
                    <div style={{ fontSize: 12, color: "#64748b" }}>{d.client} · {d.so_number}</div>
                  </div>
                  <span style={{ fontSize: 10, fontWeight: 600, background: d.status === "problema" ? "#fff1f2" : "#dcfce7", color: d.status === "problema" ? "#9f1239" : "#166534", padding: "3px 8px", borderRadius: 12, flexShrink: 0, marginLeft: 8 }}>
                    {d.status === "problema" ? "Problema" : "Completado"}
                  </span>
                </div>
                <div style={{ fontSize: 11, color: "#94a3b8", display: "flex", gap: 10, flexWrap: "wrap" }}>
                  <span>📅 {formatDate(d.date)}</span>
                  {dMats.length > 0 && <span>📦 {dMats.length} material{dMats.length !== 1 ? "es" : ""}</span>}
                  {d.recipient_name && <span>✍️ {d.recipient_name}</span>}
                </div>
              </div>
            );
          })}
        </div>
      );
    })()}
  </div>
)}

      {step === 0 && !viewingDispatch && showHistory && selectedHistory && (() => {
        const hd = selectedHistory;
        const hMats = safeParse(hd.materials_manifest, []);
        return (
          <div style={{ background: "white", borderRadius: 16, border: "1px solid #e2e8f0", padding: 20 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16 }}>
              <div>
                <h2 style={{ fontSize: 17, fontWeight: 700, color: brandGreen, margin: 0 }}>{hd.project}</h2>
                <p style={{ fontSize: 13, color: "#64748b", margin: "4px 0 0" }}>{hd.client}</p>
              </div>
              <div style={{ display: "flex", gap: 6, flexDirection: "column", alignItems: "flex-end" }}>
                <DispatchTypeBadge type={hd.dispatch_type} />
                <span style={{ fontSize: 10, fontWeight: 600, background: hd.status === "problema" ? "#fff1f2" : "#dcfce7", color: hd.status === "problema" ? "#9f1239" : "#166534", padding: "3px 10px", borderRadius: 12 }}>
                  {hd.status === "problema" ? "Problema" : "Completado"}
                </span>
              </div>
            </div>
            <div style={{ background: "#f8fafc", borderRadius: 10, padding: 14, marginBottom: 16 }}>
              {[["SO#", hd.so_number], ["Fecha", formatDate(hd.date)], ["Recibido por", hd.recipient_name || "—"]].map(([k, v]) => (
                <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, padding: "5px 0", borderBottom: "1px solid #e2e8f0" }}>
                  <span style={{ color: "#64748b" }}>{k}</span>
                  <span style={{ fontWeight: 500, color: brandGreen }}>{v}</span>
                </div>
              ))}
            </div>
            {hMats.length > 0 && (
              <div>
                <p style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 }}>Materiales</p>
                {hMats.map((m, i) => (
                  <div key={i} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, padding: "5px 0", borderBottom: "1px solid #f1f5f9" }}>
                    <span style={{ color: "#374151" }}>{m.name}</span>
                    <span style={{ fontWeight: 600, color: brandGreen }}>{m.quantity} {m.unit}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })()}

      {step === 0 && viewingDispatch && (() => {
        const vd = viewingDispatch;
        const vLocs = safeParse(vd.locations, []);
        const vMats = safeParse(vd.materials_manifest, []);
        return (
          <div style={{ background: "white", borderRadius: 16, border: "1px solid #e2e8f0", padding: 20 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16 }}>
              <div>
                <h2 style={{ fontSize: 17, fontWeight: 700, color: brandGreen, margin: 0 }}>{vd.project}</h2>
                <p style={{ fontSize: 13, color: "#64748b", margin: "4px 0 0" }}>{vd.client}</p>
              </div>
              <div style={{ display: "flex", gap: 6, flexDirection: "column", alignItems: "flex-end" }}>
                <DispatchTypeBadge type={vd.dispatch_type} />
                <StatusBadge status={vd.status} />
              </div>
            </div>
            <div style={{ background: "#f8fafc", borderRadius: 10, padding: 14, marginBottom: 16 }}>
              {[["SO#", vd.so_number], ["Conductor", vd.driver === "Subcontratista" ? vd.subcontractor_name || "Subcontratista" : vd.driver], ["Fecha", formatDate(vd.date)]].map(([k, v]) => (
                <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, padding: "5px 0", borderBottom: "1px solid #e2e8f0" }}>
                  <span style={{ color: "#64748b" }}>{k}</span>
                  <span style={{ fontWeight: 500, color: brandGreen }}>{v}</span>
                </div>
              ))}
            </div>
            {vLocs.length > 0 && (
              <div style={{ marginBottom: 14 }}>
                <p style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 }}>Ubicaciones</p>
                {vLocs.map((l, i) => (
                  <div key={i} style={{ background: "#f8fafc", borderRadius: 8, padding: "8px 10px", marginBottom: 6, fontSize: 13 }}>
                    <div style={{ fontWeight: 600, color: brandGreen }}>📍 {l.floor}</div>
                    {l.address && <div style={{ color: "#64748b", fontSize: 12 }}>{l.address}</div>}
                    {l.contact && <div style={{ color: "#64748b", fontSize: 12 }}>👤 {l.contact}</div>}
                    {l.notes && <div style={{ color: "#92400e", fontSize: 12 }}>⚠️ {l.notes}</div>}
                  </div>
                ))}
              </div>
            )}
            {vMats.length > 0 && (
              <div style={{ marginBottom: 14 }}>
                <p style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 }}>Materiales a despachar</p>
                {vMats.map((m, i) => (
                  <div key={i} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, padding: "5px 0", borderBottom: "1px solid #f1f5f9" }}>
                    <span style={{ color: "#374151" }}>{m.name}</span>
                    <span style={{ fontWeight: 600, color: brandGreen }}>{m.quantity} {m.unit}</span>
                  </div>
                ))}
              </div>
            )}
            {vd.special_notes && (
              <div style={{ fontSize: 12, color: "#92400e", background: "#fff7ed", border: "1px solid #fed7aa", borderRadius: 8, padding: "8px 10px", marginBottom: 14 }}>⚠️ {vd.special_notes}</div>
            )}
            <button onClick={() => setViewingDispatch(null)} style={{ width: "100%", padding: "12px", borderRadius: 10, border: `2px solid ${brandGreen}`, color: brandGreen, background: "none", fontSize: 14, fontWeight: 600, cursor: "pointer" }}>← Volver a mis entregas</button>
          </div>
        );
      })()}

        {step === 1 && selected && (
          <div>
            <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 12, padding: 14, marginBottom: 16, fontSize: 12, color: "#166534", fontWeight: 500 }}>✅ Marcado como En Ruta</div>
            <div style={{ background: "white", borderRadius: 14, border: "1px solid #e2e8f0", padding: 18, marginBottom: 16 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
                <p style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.08em", margin: 0 }}>Confirma el despacho</p>
                <DispatchTypeBadge type={selected.dispatch_type} />
              </div>
              {[["Cliente", selected.client], ["Proyecto", selected.project], ["SO#", selected.so_number]].map(([k, v]) => <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: 14, padding: "8px 0", borderBottom: "1px solid #f1f5f9" }}><span style={{ color: "#64748b" }}>{k}</span><span style={{ fontWeight: 600, color: brandGreen }}>{v}</span></div>)}
              {locs.length > 0 && <div style={{ marginTop: 12 }}><p style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 }}>Ubicaciones</p>{locs.map((l, i) => <div key={i} style={{ background: "#f8fafc", borderRadius: 8, padding: "8px 10px", marginBottom: 6, fontSize: 13 }}><div style={{ fontWeight: 600, color: brandGreen }}>📍 {l.floor}</div>{l.contact && <div style={{ fontSize: 12, color: "#64748b" }}>👤 {l.contact}</div>}{l.notes && <div style={{ fontSize: 12, color: "#92400e" }}>⚠️ {l.notes}</div>}</div>)}</div>}
              {mats.length > 0 && (
                <div style={{ marginTop: 12 }}>
                  <p style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 }}>Materiales a despachar</p>
                  <div style={{ background: "#f8fafc", borderRadius: 8, padding: "8px 10px" }}>
                    {mats.map((m, i) => <div key={i} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, padding: "4px 0", borderBottom: i < mats.length - 1 ? "1px solid #e2e8f0" : "none" }}><span style={{ color: "#374151" }}>{m.name}</span><span style={{ fontWeight: 600, color: brandGreen }}>{m.quantity} {m.unit}</span></div>)}
                  </div>
                  <p style={{ fontSize: 11, color: "#94a3b8", marginTop: 6 }}>Compara esta lista con el "Warehouse Out" de Odoo antes de continuar.</p>
                </div>
              )}
              {selected.special_notes && <div style={{ marginTop: 10, fontSize: 12, color: "#92400e", background: "#fff7ed", border: "1px solid #fed7aa", borderRadius: 8, padding: "8px 10px" }}>⚠️ {selected.special_notes}</div>}
              {selected.destination_zone === "Este (Cap Cana / Casa de Campo / Punta Cana)" && (
                <div style={{ marginTop: 10 }}>
                  <div style={{ background: "#fff7ed", border: "1.5px solid #f97316", borderRadius: 8, padding: "8px 12px", fontSize: 13, fontWeight: 700, color: "#92400e", marginBottom: selected.access_pass_url ? 10 : 0 }}>🌴 ENTREGA ESTE — Cap Cana / Casa de Campo / Punta Cana</div>
                  {selected.access_pass_url && (
                    <div>
                      <p style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.08em", margin: "0 0 6px" }}>Pase de acceso</p>
                      <img src={selected.access_pass_url} alt="Pase de acceso" style={{ width: "100%", borderRadius: 8, border: "1.5px solid #fed7aa" }} />
                    </div>
                  )}
                </div>
              )}
            </div>
            <button onClick={() => goToStep(2)} style={{ width: "100%", padding: "13px", borderRadius: 10, background: brandGreen, color: "white", fontSize: 14, fontWeight: 600, border: "none", cursor: "pointer" }}>Todo correcto →</button>
            {(selected.dispatch_type || "entrega") === "entrega" && (
              <button onClick={() => { setHasIssue(true); goToStep(3); }} style={{ width: "100%", padding: "10px", marginTop: 8, borderRadius: 10, background: "none", color: "#94a3b8", fontSize: 13, border: "1px solid #e2e8f0", cursor: "pointer" }}>Reportar problema</button>
            )}
          </div>
        )}

        {step === 2 && (
          <div>
            {/* STEP 2: ENTREGA — arrival photos (unchanged) */}
            {(selected.dispatch_type || "entrega") === "entrega" && (
              <>
                <h2 style={{ fontSize: 17, fontWeight: 700, color: brandGreen, marginBottom: 6, marginTop: 0 }}>Fotos de llegada</h2>
                <p style={{ fontSize: 13, color: "#64748b", marginBottom: 20 }}>Toma las fotos antes de descargar. Hasta 6 por requisito.</p>
                <div style={{ display: "flex", flexDirection: "column", gap: 20, marginBottom: 20 }}>
                  {[["camion", "📦 Material en el camión"], ["fachada", "🏢 Fachada / entrada del edificio"], ["deposito", "🏠 Área donde se va a dejar el material"]].map(([key, label]) => (
                    <div key={key}>
                      <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 8 }}>{label}</label>
                      <MultiPhotoCapture category={key} isDelivery={false} photos={arrivalPhotos[key] || []} onCapture={capturePhoto} onRemove={removePhoto} />
                    </div>
                  ))}
                </div>
                <button onClick={() => goToStep(3)} disabled={!arrivalPhotos.camion?.length || !arrivalPhotos.fachada?.length || !arrivalPhotos.deposito?.length} style={{ width: "100%", padding: "13px", borderRadius: 10, background: brandGreen, color: "white", fontSize: 14, fontWeight: 600, border: "none", cursor: "pointer", opacity: (!arrivalPhotos.camion?.length || !arrivalPhotos.fachada?.length || !arrivalPhotos.deposito?.length) ? 0.4 : 1 }}>Continuar →</button>
              </>
            )}

            {/* STEP 2: RETIRO — material in client's truck + signed conduce */}
            {selected.dispatch_type === "retiro" && (
              <>
                <h2 style={{ fontSize: 17, fontWeight: 700, color: brandGreen, marginBottom: 6, marginTop: 0 }}>Fotos del retiro</h2>
                <p style={{ fontSize: 13, color: "#64748b", marginBottom: 20 }}>Registra las fotos requeridas antes de continuar.</p>
                <div style={{ display: "flex", flexDirection: "column", gap: 20, marginBottom: 20 }}>
                  <div>
                    <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 8 }}>📦 Material en el camión del cliente <span style={{ color: "#f43f5e" }}>*</span></label>
                    <MultiPhotoCapture category="camion" isDelivery={false} photos={arrivalPhotos.camion || []} onCapture={capturePhoto} onRemove={removePhoto} />
                    {!arrivalPhotos.camion?.length && <p style={{ fontSize: 11, color: "#f43f5e", margin: "6px 0 0" }}>Requerido</p>}
                  </div>
                  <div>
                    <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 8 }}>📄 Conduce firmado <span style={{ color: "#f43f5e" }}>*</span></label>
                    <MultiPhotoCapture category="conduce" isDelivery={false} photos={conducePhotos} onCapture={captureConducePhoto} onRemove={removeConducePhoto} />
                    {!conducePhotos.length && <p style={{ fontSize: 11, color: "#f43f5e", margin: "6px 0 0" }}>Requerido</p>}
                  </div>
                </div>
                <button onClick={() => goToStep(3)} disabled={!arrivalPhotos.camion?.length || !conducePhotos.length} style={{ width: "100%", padding: "13px", borderRadius: 10, background: brandGreen, color: "white", fontSize: 14, fontWeight: 600, border: "none", cursor: "pointer", opacity: (!arrivalPhotos.camion?.length || !conducePhotos.length) ? 0.4 : 1 }}>Continuar →</button>
              </>
            )}

            {/* STEP 2: RECOGIDA — conduce + authorizing person + materials */}
            {selected.dispatch_type === "recogida" && (
              <>
                <h2 style={{ fontSize: 17, fontWeight: 700, color: brandGreen, marginBottom: 6, marginTop: 0 }}>Fotos de la recogida</h2>
                <p style={{ fontSize: 13, color: "#64748b", marginBottom: 20 }}>Registra las fotos requeridas antes de continuar.</p>
                <div style={{ display: "flex", flexDirection: "column", gap: 20, marginBottom: 20 }}>
                  <div>
                    <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 8 }}>📄 Conduce firmado <span style={{ color: "#f43f5e" }}>*</span></label>
                    <MultiPhotoCapture category="conduce" isDelivery={false} photos={conducePhotos} onCapture={captureConducePhoto} onRemove={removeConducePhoto} />
                    {!conducePhotos.length && <p style={{ fontSize: 11, color: "#f43f5e", margin: "6px 0 0" }}>Requerido</p>}
                  </div>
                  <div>
                    <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 8 }}>👤 Persona autorizando la recogida <span style={{ color: "#f43f5e" }}>*</span></label>
                    <MultiPhotoCapture category="autorizacion" isDelivery={false} photos={arrivalPhotos.autorizacion || []} onCapture={capturePhoto} onRemove={removePhoto} />
                    {!arrivalPhotos.autorizacion?.length && <p style={{ fontSize: 11, color: "#f43f5e", margin: "6px 0 0" }}>Requerido</p>}
                  </div>
                  <div>
                    <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 8 }}>📦 Materiales en camión / almacén <span style={{ color: "#f43f5e" }}>*</span></label>
                    <MultiPhotoCapture category="camion" isDelivery={false} photos={arrivalPhotos.camion || []} onCapture={capturePhoto} onRemove={removePhoto} />
                    {!arrivalPhotos.camion?.length && <p style={{ fontSize: 11, color: "#f43f5e", margin: "6px 0 0" }}>Requerido</p>}
                  </div>
                </div>
                <button onClick={() => goToStep(3)} disabled={!conducePhotos.length || !arrivalPhotos.autorizacion?.length || !arrivalPhotos.camion?.length} style={{ width: "100%", padding: "13px", borderRadius: 10, background: brandGreen, color: "white", fontSize: 14, fontWeight: 600, border: "none", cursor: "pointer", opacity: (!conducePhotos.length || !arrivalPhotos.autorizacion?.length || !arrivalPhotos.camion?.length) ? 0.4 : 1 }}>Continuar →</button>
              </>
            )}
          </div>
        )}

        {step === 3 && (
          <div>
            {/* STEP 3: ENTREGA — material checklist + delivery photos + conduce + issue (unchanged) */}
            {(selected.dispatch_type || "entrega") === "entrega" && (
              <>
                <h2 style={{ fontSize: 17, fontWeight: 700, color: brandGreen, marginBottom: 6, marginTop: 0 }}>Confirmación de entrega</h2>
                <p style={{ fontSize: 13, color: "#64748b", marginBottom: 16 }}>Confirma las cantidades dejadas en obra.</p>
                {materialChecklist.length > 0 ? (
                  <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 16 }}>
                    {materialChecklist.map((m, i) => (
                      <div key={i} style={{ background: m.confirmed ? "#f0fdf4" : "white", border: `1.5px solid ${m.confirmed ? "#bbf7d0" : "#e2e8f0"}`, borderRadius: 10, padding: "12px 14px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <button onClick={() => toggleMaterial(i)} style={{ width: 24, height: 24, borderRadius: 6, border: `2px solid ${m.confirmed ? "#059669" : "#d1d5db"}`, background: m.confirmed ? "#059669" : "white", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                            {m.confirmed && <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>}
                          </button>
                          <div style={{ flex: 1 }}><div style={{ fontSize: 14, fontWeight: 500, color: brandGreen }}>{m.name}</div><div style={{ fontSize: 12, color: "#94a3b8" }}>Esperado: {m.quantity} {m.unit}</div></div>
                          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                            <input type="number" value={m.actual_quantity} onChange={e => updateMaterialQty(i, e.target.value)} style={{ width: 56, padding: "5px 8px", borderRadius: 6, border: "1px solid #e2e8f0", fontSize: 13, textAlign: "center" }} />
                            <span style={{ fontSize: 12, color: "#94a3b8" }}>{m.unit}</span>
                          </div>
                        </div>
                        {m.actual_quantity !== m.quantity && <div style={{ fontSize: 11, color: "#f59e0b", marginTop: 4, marginLeft: 34 }}>⚠️ Diferencia con lo despachado</div>}
                      </div>
                    ))}
                  </div>
                ) : <div style={{ background: "#f8fafc", borderRadius: 10, padding: 14, marginBottom: 16, fontSize: 13, color: "#64748b", textAlign: "center" }}>No hay materiales listados para este despacho</div>}
                <div style={{ marginBottom: 16 }}>
                  <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 8 }}>📸 Fotos del material en obra</label>
                  <MultiPhotoCapture category="entrega" isDelivery={true} photos={deliveryPhotos} onCapture={capturePhoto} onRemove={removePhoto} />
                </div>
                <div style={{ marginBottom: 16 }}>
                  <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 8 }}>📄 Conduce firmado <span style={{ color: "#f43f5e" }}>*</span></label>
                  <MultiPhotoCapture category="conduce" isDelivery={false} photos={conducePhotos} onCapture={captureConducePhoto} onRemove={removeConducePhoto} />
                  {!conducePhotos.length && <p style={{ fontSize: 11, color: "#f43f5e", margin: "6px 0 0" }}>Requerido — toma foto del conduce firmado</p>}
                </div>
                <div style={{ marginBottom: 16 }}>
                  <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 8 }}>¿Hubo algún inconveniente?</label>
                  <div style={{ display: "flex", gap: 8 }}>
                    {[{ v: false, label: "No, todo correcto" }, { v: true, label: "Sí, hay problema" }].map(opt => <button key={String(opt.v)} onClick={() => setHasIssue(opt.v)} style={{ flex: 1, padding: "10px 8px", borderRadius: 10, border: `1.5px solid ${hasIssue === opt.v ? brandGreen : "#e2e8f0"}`, background: hasIssue === opt.v ? "#f0fdf4" : "white", fontSize: 13, fontWeight: 500, color: hasIssue === opt.v ? brandGreen : "#64748b", cursor: "pointer" }}>{opt.label}</button>)}
                  </div>
                </div>
                {hasIssue && <div style={{ marginBottom: 16 }}><label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 6 }}>Describe el problema</label><textarea value={deliveryNotes} onChange={e => setDeliveryNotes(e.target.value)} placeholder="Ej: 2 cajas dañadas..." rows={3} style={{ width: "100%", padding: "11px 14px", borderRadius: 10, border: "1.5px solid #e2e8f0", fontSize: 14, outline: "none", background: "white", boxSizing: "border-box", resize: "vertical" }} /></div>}
                <button onClick={() => goToStep(4)} disabled={!deliveryPhotos.length || !conducePhotos.length} style={{ width: "100%", padding: "13px", borderRadius: 10, background: brandGreen, color: "white", fontSize: 14, fontWeight: 600, border: "none", cursor: "pointer", opacity: (!deliveryPhotos.length || !conducePhotos.length) ? 0.4 : 1 }}>Continuar →</button>
              </>
            )}

            {/* STEP 3: RETIRO / RECOGIDA — signature screen */}
            {(selected.dispatch_type === "retiro" || selected.dispatch_type === "recogida") && (
              <>
                <h2 style={{ fontSize: 17, fontWeight: 700, color: brandGreen, marginBottom: 6, marginTop: 0 }}>
                  {selected.dispatch_type === "retiro" ? "Firma de quien retira" : "Firma de quien autoriza"}
                </h2>
                <p style={{ fontSize: 13, color: "#64748b", marginBottom: 20 }}>
                  {selected.dispatch_type === "retiro" ? "Pide a quien retira el material que firme aquí." : "Pide a quien autoriza la recogida que firme aquí."}
                </p>
                <div style={{ marginBottom: 16 }}>
                  <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 6 }}>
                    {selected.dispatch_type === "retiro" ? "Nombre de quien retira" : "Nombre de quien autoriza"}
                  </label>
                  <input type="text" value={recipientName} onChange={e => setRecipientName(e.target.value)} placeholder="Nombre completo" style={{ width: "100%", padding: "11px 14px", borderRadius: 10, border: "1.5px solid #e2e8f0", fontSize: 14, outline: "none", background: "white", boxSizing: "border-box" }} />
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 6 }}>Firma</label>
                  <SignaturePad onSign={setSignature} signed={!!signature} />
                </div>
                <button onClick={handleSubmit} disabled={!recipientName || !signature || submitting} style={{ width: "100%", padding: "13px", borderRadius: 10, background: "#059669", color: "white", fontSize: 14, fontWeight: 600, border: "none", cursor: "pointer", opacity: (!recipientName || !signature || submitting) ? 0.4 : 1 }}>{submitting ? "Enviando..." : "Confirmar y Enviar ✓"}</button>
              </>
            )}
          </div>
        )}

        {/* Step 4: Entrega only — signature of recipient */}
        {step === 4 && selected && (selected.dispatch_type || "entrega") === "entrega" && (
          <div>
            <h2 style={{ fontSize: 17, fontWeight: 700, color: brandGreen, marginBottom: 6, marginTop: 0 }}>Firma del receptor</h2>
            <p style={{ fontSize: 13, color: "#64748b", marginBottom: 20 }}>Pide a quien recibe que firme aquí.</p>
            <div style={{ marginBottom: 16 }}><label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 6 }}>Nombre de quien recibe</label><input type="text" value={recipientName} onChange={e => setRecipientName(e.target.value)} placeholder="Nombre completo" style={{ width: "100%", padding: "11px 14px", borderRadius: 10, border: "1.5px solid #e2e8f0", fontSize: 14, outline: "none", background: "white", boxSizing: "border-box" }} /></div>
            <div style={{ marginBottom: 20 }}><label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 6 }}>Firma</label><SignaturePad onSign={setSignature} signed={!!signature} /></div>
            <button onClick={handleSubmit} disabled={!recipientName || !signature || submitting} style={{ width: "100%", padding: "13px", borderRadius: 10, background: "#059669", color: "white", fontSize: 14, fontWeight: 600, border: "none", cursor: "pointer", opacity: (!recipientName || !signature || submitting) ? 0.4 : 1 }}>{submitting ? "Enviando..." : "Confirmar y Enviar ✓"}</button>
          </div>
        )}

        {step === 5 && selected && (
          <div style={{ textAlign: "center", paddingTop: 40 }}>
            <div style={{ width: 72, height: 72, borderRadius: "50%", background: "#f0fdf4", border: "3px solid #059669", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            </div>
            <h2 style={{ fontSize: 20, fontWeight: 700, color: brandGreen, marginBottom: 8 }}>
              {selected.dispatch_type === "retiro" ? "Retiro Registrado" : selected.dispatch_type === "recogida" ? "Recogida Registrada" : "Entrega Registrada"}
            </h2>
            <p style={{ fontSize: 14, color: "#64748b", marginBottom: 20 }}>{selected.project}</p>
            <div style={{ background: "white", borderRadius: 12, border: "1px solid #e2e8f0", padding: 16, display: "inline-block", marginBottom: 24, textAlign: "left" }}>
              <p style={{ fontSize: 11, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.08em", margin: "0 0 4px" }}>Referencia</p>
              <p style={{ fontSize: 16, fontWeight: 700, fontFamily: "monospace", color: brandGreen, margin: 0 }}>{selected.so_number}</p>
              <p style={{ fontSize: 12, color: "#94a3b8", margin: "4px 0 0" }}>{new Date().toLocaleTimeString("es-DO", { hour: "2-digit", minute: "2-digit" })} — {selected.dispatch_type === "retiro" ? "Retirado por" : selected.dispatch_type === "recogida" ? "Autorizado por" : "Recibido por"}: {recipientName}</p>
            </div>
            <div><button onClick={reset} style={{ padding: "12px 24px", borderRadius: 10, border: `2px solid ${brandGreen}`, color: brandGreen, background: "none", fontSize: 14, fontWeight: 600, cursor: "pointer" }}>Ver mis despachos</button></div>
          </div>
        )}
      </div>
    </div>
  );
}
export default function App() {
  const isDriver = window.location.pathname.includes("driver") || window.location.search.includes("driver");
  return isDriver ? <DriverView /> : <AdminView />;
}